// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collections-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  scroll-behavior: smooth;
}

/* Toast Message Styling */
.toast-success {
  background-color: #e8f5e8 !important;
  color: #2e7d32 !important;
  border: 1px solid #2e7d32 !important;
}

.toast-success .toast-close-button {
  color: #2e7d32 !important;
}

.toast-error {
  background-color: #f44336 !important;
  color: white !important;
}

.toast-error .toast-close-button {
  color: white !important;
}

.toast-warning {
  background-color: #ff9800 !important;
  color: white !important;
}

.toast-warning .toast-close-button {
  color: white !important;
}

.toast-info {
  background-color: #2196f3 !important;
  color: white !important;
}

.toast-info .toast-close-button {
  color: white !important;
}

/* Toast message structure */
.toast-message {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  /* padding: 0 8px; */
}

.toast-message-text {
  flex: 1 1;
}

.toast-close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 4px;
  /* align-items: end !important; */
  /* margin-left: 12px; */
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
}

/* Custom toast animation */
@keyframes slideDownFromTop {
  0% {
    transform: translateX(-50%) translateY(-100px);
    opacity: 0;
  }

  50% {
    transform: translateX(-50%) translateY(-20px);
    opacity: 0.8;
  }

  100% {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

.Toastify__toast-container {
  top: 0 !important;
}

.Toastify__toast {
  min-height: 60px !important;
  min-width: 400px !important;
  margin-top: 55px !important;
  z-index: 9999 !important;
}

.Toastify__toast--success {
  background-color: #d4edda !important;
  color: #155724 !important;
}

.Toastify__toast--success .Toastify__toast-body {
  color: #155724 !important;
}

.Toastify__toast--success .Toastify__close-button {
  color: #155724 !important;
  font-size: 20px !important;
  padding: 8px 12px !important;
  opacity: 0.8 !important;
  pointer-events: auto !important;
  z-index: 10000 !important;
  position: absolute !important;
  right: 8px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  cursor: pointer !important;
}

.Toastify__toast--success .Toastify__close-button:hover {
  opacity: 1 !important;
  background-color: rgba(21, 87, 36, 0.1) !important;
  border-radius: 4px !important;
}

.Toastify__close-button {
  pointer-events: auto !important;
  z-index: 10001 !important;
  position: relative !important;
}

/* Mobile responsive styles for toast notifications */
@media (max-width: 768px) {
  .Toastify__toast-container {
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    padding: 0 10px !important;
    box-sizing: border-box !important;
  }

  .Toastify__toast {
    min-width: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-top: 10px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    left: 0 !important;
    transform: none !important;
    border-radius: 8px !important;
    min-height: 50px !important;
  }

  .Toastify__toast--success {
    font-size: 14px !important;
  }

  .Toastify__toast--success .Toastify__toast-body {
    font-size: 14px !important;
    padding: 8px 12px !important;
  }

  .Toastify__toast--success .Toastify__close-button {
    font-size: 18px !important;
    padding: 6px 10px !important;
  }

  .toast-message {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .toast-message-text {
    flex: 1 1;
    word-break: break-word;
    line-height: 1.4;
  }
}

/* Extra small mobile screens */
@media (max-width: 480px) {
  .Toastify__toast {
    min-height: 45px !important;
    margin-top: 5px !important;
  }

  .Toastify__toast--success {
    font-size: 13px !important;
  }

  .Toastify__toast--success .Toastify__toast-body {
    font-size: 13px !important;
    padding: 6px 10px !important;
  }

  .Toastify__toast--success .Toastify__close-button {
    font-size: 16px !important;
    padding: 4px 8px !important;
  }
}

/* Ensure page starts from top */
html,
body {
  scroll-behavior: smooth;
  margin: 0;
  padding: 0;
}

/* Override any scroll positioning issues */
.collections-container>* {
  scroll-margin-top: 0;
}

/* Force page to start from top */
#root {
  scroll-behavior: smooth;
}

/* Remove any scroll offset issues within collections */
.collections-container,
.collections-container * {
  scroll-margin-top: 0;
}

/* Mobile-specific fixes */
@media (max-width: 768px) {

  html,
  body {
    scroll-behavior: smooth;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    position: relative;
  }

  .collections-container {
    scroll-behavior: smooth;
    min-height: 100vh;
    width: 100%;
    overflow-x: hidden;
    position: relative;
  }

  /* Force scroll to top on mobile */
  .collections-container>* {
    scroll-margin-top: 0;
  }

  /* Remove any fixed positioning that might cause issues */
  .collections-header {
    position: relative !important;
    top: auto !important;
    z-index: auto !important;
  }

  /* Ensure table containers don't cause horizontal scroll */
  .collections-table-container,
  .preview-table-container {
    overflow-x: auto;
    max-width: 100%;
    position: relative;
  }

  /* Fix for mobile viewport issues */
  .collections-content {
    padding: 1rem;
    width: 100%;
    box-sizing: border-box;
  }

  /* Ensure no horizontal scroll on mobile */
  .collections-table {
    min-width: 1200px;
    width: 100%;
  }

  /* Mobile edit modal styles */
  .edit-collection-modal {
    max-width: 95%;
    width: 95%;
    min-width: 300px;
    max-height: 95vh;
    margin: 10px;
    border-radius: 12px;
  }

  .edit-collection-container {
    padding: 15px;
  }

  .edit-form-row {
    flex-direction: column;
    gap: 12px;
    margin-bottom: 12px;
  }

  .edit-form-group {
    flex: 1 1;
  }

  .edit-form-input {
    padding: 12px;
    font-size: 16px;
    border-radius: 8px;
  }

  .edit-form-input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }

  .edit-form-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
  }

  .edit-form-button {
    padding: 12px 20px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .edit-form-button.cancel {
    background-color: #f3f4f6;
    color: #374151;
  }

  .edit-form-button.preview {
    background-color: #2563eb;
    color: white;
  }

  .edit-form-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .calculation-results {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-top: 15px;
  }

  .calculation-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .calculation-item label {
    font-weight: 500;
    color: #6b7280;
  }

  .calculation-item span {
    font-weight: 600;
    color: #111827;
  }

  /* Mobile edit modal styles */
  .edit-collection-modal {
    max-width: 95%;
    width: 95%;
    min-width: 300px;
    max-height: 95vh;
    margin: 10px;
    border-radius: 12px;
  }

  .edit-collection-container {
    padding: 15px;
  }

  .edit-form-row {
    flex-direction: row;
    gap: 12px;
    margin-bottom: 12px;
  }

  /* Stack only on very small screens */
  @media (max-width: 480px) {
    .edit-form-row {
      flex-direction: column;
      gap: 12px;
    }
  }

  .edit-form-group {
    flex: 1 1;
  }

  .edit-form-input {
    padding: 12px;
    font-size: 16px;
    border-radius: 8px;
  }

  .edit-form-input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }

  .edit-form-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
  }

  .edit-form-button {
    padding: 12px 20px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .edit-form-button.cancel {
    background-color: #f3f4f6;
    color: #374151;
  }

  .edit-form-button.preview {
    background-color: #2563eb;
    color: white;
  }

  .edit-form-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .calculation-results {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-top: 15px;
  }

  .calculation-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .calculation-item label {
    font-weight: 500;
    color: #6b7280;
  }

  .calculation-item span {
    font-weight: 600;
    color: #111827;
  }

  /* Mobile-specific modal fixes */
  .modal-overlay {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 9999 !important;
  }
}

/* Extra small mobile screens */
@media (max-width: 480px) {

  html,
  body {
    scroll-behavior: smooth;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    position: relative;
  }

  .collections-container {
    scroll-behavior: smooth;
    min-height: 100vh;
    width: 100%;
    overflow-x: hidden;
    position: relative;
  }

  .collections-content {
    padding: 0.5rem;
    width: 100%;
    box-sizing: border-box;
  }

  .collections-header {
    position: relative !important;
    top: auto !important;
    padding: 0.8rem !important;
  }
}

.collections-header {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.2rem 2.5rem;
  /* background: linear-gradient(120deg, #eef2ff 0%, #e0f2fe 40%, #e0f7fa 100%); */
  background: linear-gradient(135deg, #0047AB 0%, #003680 100%) !important;
  box-shadow: 0 20px 45px rgba(79, 70, 229, 0.15);
  position: relative;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  border-bottom: 1px solid rgba(99, 102, 241, 0.15);
}

.header-desktop {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr);
  align-items: center;
}

.header-left,
.header-right {
  /* color: white !important; */
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.header-primary {
  display: flex;
  align-items: center;
  gap: 1rem;
  grid-column: span 2;
}

.header-left {
  justify-content: flex-start;
}

.header-center h1 {
  color: white !important;
}

.header-center {
  /* color: white; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  text-align: center;
}

.header-right {
  justify-content: flex-end;
  gap: 1rem;
}

.collections-header h1 {
  margin: 0;
  font-size: 1.6rem;
  color: #0f172a;
  font-weight: 700;
}

.header-search {
  position: relative;
  width: auto;
}

.header-search .search-input.small {
  max-width: 220px;
  min-width: 200px;
}

.collections-header .language-switcher .lang-btn {
  background: #111827;
  border: 1px solid rgba(17, 24, 39, 0.7);
  color: #f9fafb;
}

.collections-header .language-switcher .lang-btn:hover {
  background: #0f172a;
  border-color: rgba(17, 24, 39, 0.85);
}

.collections-header .language-switcher .lang-icon,
.collections-header .language-switcher .lang-text,
.collections-header .language-switcher .lang-chevron {
  color: #f9fafb;
}

.header-desktop {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr);
  align-items: center;
}

.header-mobile-top,
.header-mobile-title,
.header-mobile-search,
.header-mobile-lang {
  display: none;
}

@media (max-width: 1024px) {

  /* Keep desktop layout visible for tablets */
  .header-desktop {
    display: grid;
  }

  /* Only hide mobile layouts for tablets, not mobile */
}

@media (min-width: 769px) and (max-width: 1024px) {

  /* Hide mobile layouts specifically for tablets */
  .header-mobile-top,
  .header-mobile-title,
  .header-mobile-search,
  .header-mobile-lang {
    display: none;
  }
}

/* Tablet specific styles (768px to 1024px) - Scale down desktop layout */
@media (min-width: 769px) and (max-width: 1024px) {
  .collections-filters {
    margin-bottom: 2rem;
  }

  /* Clickable table rows */
  .collection-row {
    transition: all 0.2s ease;
    cursor: default;
  }

  .collection-row.clickable-row:hover {
    background-color: rgba(37, 99, 235, 0.05);
    cursor: pointer;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
  }

  .collection-row.clickable-row:active {
    background-color: rgba(37, 99, 235, 0.1);
    transform: translateY(0px);
  }

  .collections-header {
    padding: 1rem 1.8rem;
    gap: 0.6rem;
  }

  .header-desktop {
    grid-template-columns: minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr);
    gap: 0.8rem;
  }

  .header-primary {
    gap: 0.8rem;
  }

  .header-left,
  .header-right {
    gap: 0.6rem;
  }

  .header-center h1 {
    font-size: 1.4rem;
  }

  .header-search .search-input.small {
    max-width: 200px;
    min-width: 180px;
    font-size: 0.9rem;
    height: 38px;
  }

  .back-button-viewCollection {
    font-size: 0.9rem;
    padding: 0.4rem 0.6rem;
  }

  .logout-button {
    font-size: 0.8rem;
    padding: 0.4rem 0.6rem;
  }

  .collections-header .language-switcher .lang-btn {
    min-width: 80px;
    padding: 4px 8px;
    font-size: 0.75rem;
  }

  /* Adjust content spacing for tablets */
  .collections-content {
    padding: 1.8rem;
  }

  /* Filter adjustments */
  .filter-button {
    padding: 10px 16px;
    font-size: 0.85rem;
    min-height: 40px;
  }
}

@media (max-width: 768px) {
  .collections-header {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
  }

  /* Hide desktop layout on mobile */
  .header-desktop {
    display: none;
  }

  /* Show mobile elements on mobile */
  .header-mobile-top,
  .header-mobile-title,
  .header-mobile-search,
  .header-mobile-lang {
    display: flex;
  }

  .header-mobile-search {
    display: block;
  }

  /* Main header row with back, title, logout */
  .header-mobile-top {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    width: 100%;
    gap: 1rem;
    position: relative;
  }

  /* Title in center */
  .header-mobile-title {
    grid-column: 2;
    text-align: center;
  }

  .header-mobile-title h1 {
    font-size: 1.3rem;
    margin: 0;
    color: white;
  }

  /* Back button on left */
  .header-mobile-top .header-left {
    grid-column: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  /* Language switcher and logout on right */
  .header-mobile-top .header-center {
    grid-column: 3;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 0.35rem;
  }

  .header-mobile-top .header-right {
    display: none;
    /* Hide the original right div */
  }

  .header-desktop {
    display: none;
  }

  /* Language switcher styling */
  .header-mobile-top .language-switcher .lang-btn {
    width: auto;
    min-width: 80px;
    padding: 4px 8px;
    font-size: 0.75rem;
  }

  /* Search bar below header */
  .header-mobile-search {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    justify-content: center;
  }

  .header-mobile-search .header-search {
    width: 100%;
    max-width: 400px;
    flex: 1 1;
  }

  .header-mobile-search .language-switcher {
    flex-shrink: 0;
  }

  .header-mobile-search .search-input {
    width: 100%;
    padding: 0.6rem 2.5rem 0.6rem 2.5rem;
    font-size: 0.9rem;
    height: 40px;
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.15);
    color: white;
    text-align: center;
  }

  .header-mobile-search .search-input::placeholder {
    color: rgba(255, 255, 255, 0.7);
    text-align: center;
  }

  .header-mobile-search .search-input:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.2);
    text-align: left;
  }

  .header-mobile-search .search-icon {
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: rgba(255, 255, 255, 0.7);
    z-index: 1;
  }

  .header-mobile-search .clear-search-icon {
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: rgba(255, 255, 255, 0.7);
    z-index: 1;
  }

  /* Button styling */
  .back-button-viewCollection {
    font-size: 1rem;
    padding: 0.5rem;
    color: white;
    display: flex;
    align-items: center;
    gap: 0.3rem;
  }

  .back-button-viewCollection span {
    display: none;
  }

  .collections-header .logout-button {
    font-size: 0.9rem;
    padding: 0.5rem;
    color: #dc3545;
    display: flex;
    align-items: center;
    gap: 0.3rem;
  }

  .collections-header .logout-button span {
    display: none;
  }
}

@media (max-width: 480px) {
  .collections-header {
    padding: 0.8rem;
    gap: 0.8rem;
  }

  .header-mobile-title h1 {
    font-size: 1.1rem;
  }

  .header-mobile-top {
    gap: 0.5rem;
  }

  .header-mobile-top .language-switcher .lang-btn {
    min-width: 70px;
    padding: 3px 6px;
    font-size: 0.7rem;
  }

  .header-mobile-search .search-input {
    height: 36px;
    font-size: 0.85rem;
    padding: 0.5rem 2rem 0.5rem 2rem;
  }

  .header-mobile-search .search-icon {
    left: 0.8rem;
  }

  .header-mobile-search .clear-search-icon {
    right: 0.8rem;
  }

  .back-button-viewCollection {
    font-size: 0.9rem;
    padding: 0.4rem;
  }

  .collections-header .logout-button {
    font-size: 0.8rem;
    padding: 0.4rem;
  }

  .collections-header {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }
}

.back-button-viewCollection {
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  text-decoration: none;
  padding: 0.4rem 0;
}

.back-button-viewCollection:hover {
  color: white;
  text-decoration: underline;
}

.back-button-viewCollection svg {
  font-size: 0.9rem;
}

.logout-button {
  background: none;
  border: none;
  color: #dc3545;
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0;
}

.logout-button svg {
  font-size: 0.9rem;
}

.logout-button:hover {
  color: #c82333;
  text-decoration: underline;
}

.collections-content {
  flex: 1 1;
  padding: 2.5rem;
  max-width: 1500px;
  margin: 0 auto;
  width: 100%;
}

.collections-search {
  margin-bottom: 1.5rem;
}

/* New filter styles */
.collections-filters {
  margin-bottom: 0.75rem !important;
}

.filter-card {
  background: white;
  border-radius: 12px !important;
  padding: 0.75rem 1rem !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: visible;
}

.filter-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at top right, rgba(79, 70, 229, 0.08), transparent 45%);
  pointer-events: none;
}

.filter-card-header {
  display: flex;
  align-items: center !important;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.5rem !important;
}

.filter-card-header h3 {
  margin: 0;
  font-size: 1.05rem !important;
  font-weight: 700;
  color: #111827;
}

.filter-card-header p {
  display: none !important;
}

.filter-card-badge {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.3);
}

@media (max-width: 768px) {
  .filter-card-badge {
    font-size: 0.75rem;
    padding: 0.4rem 0.8rem;
  }
}

.report-button-wrapper {
  display: flex;
  align-items: stretch;
}

.filter-options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem !important;
  align-items: center;
  justify-content: flex-start;
}

.filter-button {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px !important;
  padding: 6px 12px !important;
  display: flex;
  align-items: center;
  gap: 6px !important;
  cursor: pointer;
  font-size: 13px !important;
  font-weight: 600;
  color: #2c3e50;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  position: relative;
  overflow: hidden;
  min-height: 32px !important;
}

.filter-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s;
}

.filter-button:hover::before {
  left: 100%;
}

.filter-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12), 0 4px 10px rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 0, 0, 0.12);
}

.filter-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.filter-button svg {
  font-size: 1.1rem;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.filter-button:hover svg {
  opacity: 1;
  transform: scale(1.1);
}

/* Premium Customer Filter Button */
.customer-filter-button {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-color: #64b5f6;
  color: #1565c0;
}

.customer-filter-button:hover {
  background: linear-gradient(135deg, #bbdefb 0%, #90caf9 100%);
  border-color: #42a5f5;
  box-shadow: 0 8px 25px rgba(33, 150, 243, 0.2), 0 4px 10px rgba(33, 150, 243, 0.15);
}

/* Premium Date Filter Button */
.filter-button.date-filter-button {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border-color: #81c784;
  color: #2e7d32;
}

.filter-button.date-filter-button:hover {
  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
  border-color: #66bb6a;
  box-shadow: 0 8px 25px rgba(76, 175, 80, 0.2), 0 4px 10px rgba(76, 175, 80, 0.15);
}

/* Premium Sort Order Button */
.filter-button.sort-order-button {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border-color: #ffb74d;
  color: #e65100;
}

.filter-button.sort-order-button:hover {
  background: linear-gradient(135deg, #ffe0b2 0%, #ffcc80 100%);
  border-color: #ffa726;
  box-shadow: 0 8px 25px rgba(255, 152, 0, 0.2), 0 4px 10px rgba(255, 152, 0, 0.15);
}

/* Premium Milk Rate Button */
.filter-button.milk-rate-button {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border-color: #00916c;
  color: #008f6a;
}

.filter-button.milk-rate-button:hover {
  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
  border-color: #4caf50;
  box-shadow: 0 8px 25px rgba(76, 175, 80, 0.25), 0 4px 10px rgba(76, 175, 80, 0.2);
}

/* Premium Bulk Update Button */
.filter-button.bulk-update-button {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border-color: #66bb6a;
  color: #2e7d32;
}

.filter-button.bulk-update-button:hover {
  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
  border-color: #4caf50;
  box-shadow: 0 8px 25px rgba(76, 175, 80, 0.25), 0 4px 10px rgba(76, 175, 80, 0.2);
}

/* Add styles for rate chart button - no background */
.filter-button.rate-chart-button {
  background-color: transparent !important;
  border: 1px solid #dee2e6 !important;
  color: #495057 !important;
}

.filter-button.rate-chart-button:hover {
  background-color: #f8f9fa !important;
  border-color: #adb5bd !important;
}

/* Add styles for rate settings button - no background */
.filter-button.rate-settings-button {
  background-color: transparent !important;
  border: 1px solid #dee2e6 !important;
  color: #495057 !important;
}

.filter-button.rate-settings-button:hover {
  background-color: #f8f9fa !important;
  border-color: #adb5bd !important;
}

.pro-rata-button {
  background-color: #f3e5f5;
  border-color: #ba68c8;
  color: #7b1fa2;
}

.pro-rata-button:hover {
  background-color: #e1bee7;
  border-color: #ab47bc;
}

.milk-rate-button {
  background-color: #fff3e0;
  border-color: #ffb74d;
  color: #e65100;
}

.milk-rate-button:hover {
  background-color: #ffe0b2;
  border-color: #ffa726;
}

.active-filter {
  display: flex;
  align-items: center;
  background-color: #e9f2ff;
  border: 1px solid #b8daff;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #0062cc;
}

.active-filter.date-filter {
  background-color: #e9fff2;
  border-color: #b8ffd9;
  color: #00a67c;
}

.active-filters-summary {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 4px solid #007bff;
  font-size: 0.9rem;
  color: #495057;
}

.active-filters-summary p {
  margin: 0;
}

.filter-action-buttons {
  display: inline-flex;
  gap: 10px;
  margin-left: 15px;
}

.clear-filter-button {
  background: rgba(108, 117, 125, 0.1);
  border: none;
  color: #6c757d;
  cursor: pointer;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}

.clear-filter-button:hover {
  background-color: rgba(108, 117, 125, 0.2);
  color: #495057;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 95%;
  max-width: 600px;
  min-width: 320px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  backdrop-filter: none;
}

.customer-modal {
  max-width: 600px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 0;
}

.date-filter-modal {
  max-width: 500px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 0;
}

/* Mobile responsive styles for date filter modal */
@media (max-width: 768px) {
  .modal-overlay {
    align-items: flex-start !important;
    justify-content: center;
    padding: 12px !important;
    padding-top: 25px !important;
    overflow-y: auto;
    min-height: 100vh;
    width: 100%;
  }

  .date-filter-modal {
    max-width: 100% !important;
    width: 85% !important;
    max-width: 350px !important;
    /* width: 320px; */
    margin: 0 auto !important;
    position: relative;
    top: 0 !important;
    border-radius: 10px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);
    background: white;
    max-height: calc(100vh - 50px);
    overflow: visible;
    display: flex;
    flex-direction: column;

  }

  .modal-content {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    max-height: none;

  }

  .modal-header {
    padding: 10px 16px;
    border-bottom: 1px solid #e9ecef;
    flex-shrink: 0;
  }

  .modal-header h2 {
    font-size: 1.05rem;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .modal-close-button {
    font-size: 1rem;
    color: #666;
    background: none;
    border: none;
    cursor: pointer;
    padding: 3px;
  }

  .date-input-group {
    margin-bottom: 14px;
    padding: 0 18px;
  }

  .date-input-group label {
    font-size: 0.85rem;
    font-weight: 500;
    color: #555;
    margin-bottom: 6px;
    display: block;
  }

  .date-input {
    padding: 10px 12px;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 6px;
    width: 100%;
    box-sizing: border-box;
  }

  .date-input:focus {
    border-color: #00a67c;
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 166, 124, 0.1);
  }

  .date-filter-actions {
    padding: 14px 18px;
    gap: 8px;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
    border-radius: 0 0 10px 10px;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
  }

  .date-filter-button {
    padding: 10px 16px;
    font-size: 0.8rem;
    font-weight: 500;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 70px;
  }

  .date-filter-button.primary {
    background: #00a67c;
    color: white;
  }

  .date-filter-button.primary:hover {
    background: #008f6a;
  }

  .date-filter-button.secondary {
    background: #f8f9fa;
    color: #666;
    border: 1px solid #ddd;
  }

  .date-filter-button.secondary:hover {
    background: #e9ecef;
  }
}

/* Extra small mobile screens */
@media (max-width: 480px) {
  .modal-overlay {
    align-items: flex-start !important;
    justify-content: center;
    padding: 8px !important;
    padding-top: 20px !important;
    overflow-y: auto;
    min-height: 100vh;
  }

  .date-filter-modal {
    max-width: 100% !important;
    width: 90% !important;
    max-width: 320px !important;
    /* width: 320px; */
    margin: 0 auto !important;
    position: relative;
    top: 0 !important;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    background: white;
    max-height: calc(100vh - 40px);
    overflow: visible;
    display: flex;
    flex-direction: column;
  }

  .modal-content {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    max-height: none;
  }

  .modal-header {
    padding: 12px 16px;
    border-bottom: 1px solid #e9ecef;
    flex-shrink: 0;
  }

  .modal-header h2 {
    font-size: 1rem;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .modal-close-button {
    font-size: 0.9rem;
    color: #666;
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px;
  }

  .date-input-group {
    margin-bottom: 12px;
    padding: 0 16px;
  }

  .date-input-group label {
    font-size: 0.8rem;
    font-weight: 500;
    color: #555;
    margin-bottom: 5px;
    display: block;
  }

  .date-input {
    padding: 9px 11px;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 5px;
    width: 100%;
    box-sizing: border-box;
  }

  .date-input:focus {
    border-color: #00a67c;
    outline: none;
    box-shadow: 0 0 0 1px rgba(0, 166, 124, 0.1);
  }

  .date-filter-actions {
    padding: 12px 16px;
    gap: 6px;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
    border-radius: 0 0 8px 8px;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
  }

  .date-filter-button {
    padding: 9px 14px;
    font-size: 0.75rem;
    font-weight: 500;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 60px;
  }

  .date-filter-button.primary {
    background: #00a67c;
    color: white;
  }

  .date-filter-button.primary:hover {
    background: #008f6a;
  }

  .date-filter-button.secondary {
    background: #f8f9fa;
    color: #666;
    border: 1px solid #ddd;
  }

  .date-filter-button.secondary:hover {
    background: #e9ecef;
  }
}

.modal-header {
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  background-color: #fff;
}

.modal-header-bulk {
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  background-color: #fff;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  color: #333;
}

.modal-close-button {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: #6c757d;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.modal-close-button:hover {
  color: #343a40;
}

.customer-search-container {
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
}

.date-filter-container {
  padding: 20px;
  background-color: white;
}

.date-input-group {
  margin-bottom: 20px;
}

.date-input-group label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #495057;
}

.date-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}

.date-input:focus {
  border-color: #00a67c;
  box-shadow: 0 0 0 0.2rem rgba(0, 166, 124, 0.25);
}

.date-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.date-filter-button {
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.date-filter-button.secondary {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #ced4da;
}

.date-filter-button.secondary:hover {
  background-color: #e9ecef;
  color: #495057;
}

.date-filter-button.primary {
  background-color: #00a67c;
  color: white;
}

.date-filter-button.primary:hover {
  background-color: #00916c;
}

.customers-list {
  padding: 0;
  overflow-y: auto;
  max-height: 400px;
  background-color: white;
}

.customer-item {
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
  transition: background-color 0.2s;
}

.customer-item:hover {
  background-color: #f8f9fa;
}

.customer-item:last-child {
  border-bottom: none;
  margin-bottom: 10px;
}

.customer-name {
  font-weight: 500;
  color: #212529;
}

.customer-code {
  color: #6c757d;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

.no-customers {
  padding: 30px 20px;
}

.search-wrapper {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
}

.clear-search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  cursor: pointer;
  transition: color 0.2s;
}

.clear-search-icon:hover {
  color: #6c757d;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
  padding-right: 2.5rem;
}

.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.collections-list {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  max-width: 100%;
}

/* Premium Collection Table Styles */
.collections-table-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  margin-bottom: 1rem;
  padding: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow-x: auto !important;
}

.collections-table {
  min-width: 1400px !important;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  overflow: hidden;
  font-size: 15px !important;
  table-layout: auto;
}

.collections-table thead tr {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

.collections-table th {
  padding: 10px 8px !important;
  font-weight: 700;
  text-align: center;
  position: relative;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  color: #2c3e50;
  border-right: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  font-size: 16px !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.collections-table th:first-child {
  border-left: none;
  border-top-left-radius: 12px;
}

.collections-table th:last-child {
  border-right: none;
  border-top-right-radius: 12px;
}

.collections-table tbody tr {
  border-bottom: 1px solid #f1f3f4;
  transition: all 0.2s ease;
}

.collections-table tbody tr:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #eef7ff 100%);
  transform: scale(1.01);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.collections-table tbody tr:nth-child(even) {
  background-color: #fafbfc;
}

.collections-table tbody tr:nth-child(even):hover {
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f4ff 100%);
}

.collections-table td {
  padding: 8px 10px !important;
  text-align: left;
  border-bottom: 1px solid #f1f3f4;
  font-size: 16.5px !important;
  font-weight: 500;
  color: #2c3e50;
  border-right: 1px solid #f8f9fa;
}

.collections-table td:first-child {
  border-left: none;
}

.collections-table td:last-child {
  border-right: none;
}

.collections-table tbody tr:last-child td {
  border-bottom: none;
}

.collections-table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 12px;
}

.collections-table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 12px;
}

/* Column widths - optimized for desktop fit */
.collections-table th:nth-child(1),
.collections-table td:nth-child(1) {
  min-width: 40px;
  text-align: center;
}

.collections-table th:nth-child(2),
.collections-table td:nth-child(2) {
  min-width: 100px;
  white-space: nowrap;
}

.collections-table th:nth-child(3),
.collections-table td:nth-child(3) {
  min-width: 60px;
  text-align: right;
}

.collections-table th:nth-child(4),
.collections-table td:nth-child(4) {
  min-width: 50px !important;
  max-width: 50px !important;
  width: 50px !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.collections-table th:nth-child(5),
.collections-table td:nth-child(5) {
  min-width: 100px;
  text-align: left;
}

.collections-table th:nth-child(n+6):nth-child(-n+14),
.collections-table td:nth-child(n+6):nth-child(-n+14) {
  min-width: 70px;
  white-space: nowrap;
  text-align: right;
}

/* SNF KG column (9th) needs extra width for full Hindi label */
.collections-table th:nth-child(9),
.collections-table td:nth-child(9) {
  min-width: 90px;
  white-space: nowrap;
  text-align: right;
}

.collections-table th:nth-child(15),
.collections-table td:nth-child(15) {
  min-width: 50px;
  text-align: center;
}

/* Keep the collection-header and collection-item rules for backward compatibility */
.collection-header {
  display: flex;
  background-color: #f1f3f5;
  padding: 1rem;
  font-weight: bold;
  border-bottom: 1px solid #dee2e6;
  position: relative;
  min-width: max-content;
}

.collection-item {
  display: flex;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s;
  min-width: max-content;
}

.collection-item:hover {
  background-color: #f8f9fa;
}

.collection-item:last-child {
  border-bottom: none;
}

.collection-column {
  min-width: 100px;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.collection-column:nth-child(1) {
  min-width: 90px;
}

.collection-column:nth-child(2) {
  min-width: 150px;
}

.collection-column:nth-child(3) {
  min-width: 130px;
}

.collection-column:nth-child(4),
.collection-column:nth-child(5),
.collection-column:nth-child(6),
.collection-column:nth-child(7),
.collection-column:nth-child(8),
.collection-column:nth-child(9) {
  min-width: 80px;
}

.collection-column:nth-child(10),
.collection-column:nth-child(11),
.collection-column:nth-child(12),
.collection-column:nth-child(13) {
  min-width: 90px;
}

.error-message {
  text-align: center;
  padding: 2rem;
  color: #dc3545;
  background-color: #f8d7da;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.error-message button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  margin-top: 1rem;
  cursor: pointer;
}

.error-message button:hover {
  background-color: #c82333;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #007bff;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.no-collections {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
  font-style: italic;
}

.load-more {
  text-align: center;
  margin: 2rem 0;
}

.load-more-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s;
  margin-bottom: 1rem;
}

.load-more-button:hover {
  background-color: #0069d9;
}

.load-custom-options {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 0.5rem;
}

.load-custom-button {
  background-color: #f8f9fa;
  color: #007bff;
  border: 1px solid #007bff;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.load-custom-button:hover {
  background-color: #007bff;
  color: white;
}

.collections-footer {
  text-align: center;
  padding: 20px 0;
  background-color: #f8f9fa;
  color: #666;
  border-top: 1px solid #e0e0e0;
}

/* Bulk Update Rate Type Selection Modal */
.rate-type-selector-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.rate-type-selector-btn:hover {
  background: #5a67d8;
}

.rate-type-selector-btn:active {
  background: #764ba2;
}

.rate-type-selection-modal {
  max-width: 350px;
  width: 85%;
  max-height: 280px;
}

.rate-type-selection-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
}

.rate-type-selection-modal .modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.rate-type-selection-modal .modal-body-rate-type {
  padding: 20px;
}

.rate-type-options {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.rate-type-option {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;
}

.rate-type-option:hover {
  border-color: #667eea;
  background-color: #f8f9ff;
}

.rate-type-option.active {
  border-color: #667eea;
  background-color: #667eea;
  color: white;
}

.rate-type-option span {
  margin-left: 8px;
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .rate-type-option span {
    font-size: 11px;
  }

  .heading-bulk-update {
    font-size: 14px !important;
  }
}

.rate-type-option svg {
  font-size: 18px;
  color: #667eea;
  width: 20px;
  height: 20px;
}

.rate-type-option.active svg {
  color: white;
}

/* Modal header content layout */
.modal-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.heading-bulk-update {
  font-size: 20px;
}

.modal-header-content h2 {
  margin: 0;
  flex: 1 1;
}

.edit-bulk-values {
  display: flex;
  flex-direction: row !important;
  gap: 5px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .rate-type-selection-modal {
    width: 95%;
    max-height: 350px;
  }

  .rate-type-option {
    padding: 16px;
  }

  .rate-type-option-content {
    gap: 12px;
  }

  .rate-type-option-content h4 {
    font-size: 15px;
  }

  .rate-type-option-content p {
    font-size: 13px;
  }

  .rate-type-selector-btn {
    padding: 4px 8px;
    font-size: 12px;
  }

  .filter-bulk {
    display: flex;
    flex-direction: row;
  }
}

/* Responsive styles */
@media (max-width: 1500px) {
  .collections-table-container {
    max-width: 100%;
  }
}

@media (max-width: 1200px) {
  .collections-content {
    max-width: 100%;
    padding: 1.5rem;
  }

  .collections-table-container {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .collections-header {
    padding: 0.75rem 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .collections-header h1 {
    font-size: 1.1rem;
    text-align: left;
    width: 100%;
  }

  .header-left,
  .header-right {
    width: 100%;
    justify-content: space-between;
  }

  .header-right {
    gap: 0.5rem;
    width: fit-content;
    /* border: solid 2px red; */
  }

  .collections-content {
    padding: 0.5rem;
    width: 100%;
    overflow-x: auto;
  }

  /* Enable horizontal scrolling on mobile */
  .collections-table-container {
    max-width: 100vw !important;
    border-radius: 6px !important;
    padding: 0.5rem !important;
    overflow-x: scroll !important;
    -webkit-overflow-scrolling: touch !important;
    width: 100vw !important;
    position: relative !important;
  }

  /* Set minimum width to accommodate all 15 columns */
  .collections-table {
    font-size: 0.8rem !important;
    table-layout: fixed !important;
    min-width: 1300px !important;
    width: 1300px !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
    overflow: visible !important;
    display: table !important;
  }

  .collections-table th,
  .collections-table td {
    padding: 6px 4px !important;
    font-size: 0.7rem !important;
    white-space: nowrap !important;
    border: 1px solid #f1f3f4 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  /* Mobile column widths - proper sizing with scroll */
  .collections-table th:nth-child(1),
  .collections-table td:nth-child(1) {
    min-width: 35px !important;
    max-width: 35px !important;
    width: 35px !important;
  }

  .collections-table th:nth-child(2),
  .collections-table td:nth-child(2) {
    min-width: 100px !important;
    max-width: 100px !important;
    width: 100px !important;
  }

  .collections-table th:nth-child(3),
  .collections-table td:nth-child(3) {
    min-width: 60px !important;
    max-width: 60px !important;
    width: 60px !important;
  }

  .collections-table th:nth-child(4),
  .collections-table td:nth-child(4) {
    min-width: 45px !important;
    max-width: 45px !important;
    width: 45px !important;
  }

  .collections-table th:nth-child(5),
  .collections-table td:nth-child(5) {
    min-width: 120px !important;
    max-width: 120px !important;
    width: 120px !important;
  }

  .collections-table th:nth-child(n+6):nth-child(-n+14),
  .collections-table td:nth-child(n+6):nth-child(-n+14) {
    min-width: 70px !important;
    max-width: 70px !important;
    width: 70px !important;
    text-align: right !important;
  }

  .collections-table th:nth-child(15),
  .collections-table td:nth-child(15) {
    min-width: 70px !important;
    max-width: 70px !important;
    width: 70px !important;
    text-align: center !important;
  }

  /* 16th column for PreviewProRataCollections */
  .collections-table th:nth-child(16),
  .collections-table td:nth-child(16) {
    min-width: 70px !important;
    max-width: 70px !important;
    width: 70px !important;
    text-align: center !important;
  }

  .collection-header,
  .collection-item {
    font-size: 0.8rem;
  }

  .collections-header h1 {
    font-size: 1.2rem;
  }

  /* Action buttons on mobile */
  .actions-cell {
    min-width: 70px !important;
    max-width: 70px !important;
    padding: 2px !important;
    gap: 2px !important;
  }

  .edit-button,
  .delete-button {
    padding: 4px 6px !important;
    font-size: 0.6rem !important;
    min-width: 30px !important;
  }

  .edit-button svg,
  .delete-button svg {
    font-size: 10px !important;
  }
}

/* Additional mobile breakpoint for smaller screens */
@media (max-width: 480px) {
  .collections-table-container {
    padding: 0.25rem !important;
  }

  .collections-table {
    min-width: 1300px !important;
    width: 1300px !important;
    font-size: 0.65rem !important;
  }

  .collections-table th,
  .collections-table td {
    padding: 4px 2px !important;
    font-size: 0.6rem !important;
  }

  .collections-table th:nth-child(2),
  .collections-table td:nth-child(2) {
    min-width: 90px !important;
    max-width: 90px !important;
    width: 90px !important;
  }

  .collections-table th:nth-child(5),
  .collections-table td:nth-child(5) {
    min-width: 100px !important;
    max-width: 100px !important;
    width: 100px !important;
  }

  .collections-table th:nth-child(n+6):nth-child(-n+14),
  .collections-table td:nth-child(n+6):nth-child(-n+14) {
    min-width: 60px !important;
    max-width: 60px !important;
    width: 60px !important;
  }

  .filter-bulk {
    display: flex;
    flex-direction: column !important;
  }
}

/* Print styles for exporting to PDF/printing */
@media print {
  .collections-table-container {
    overflow: visible;
    width: 100%;
    box-shadow: none;
  }

  .collections-table {
    width: 100%;
    border: 1px solid #000;
  }

  .collections-table th,
  .collections-table td {
    border: 1px solid #000;
  }

  .collections-header,
  .collections-footer,
  .collections-search,
  .load-more {
    display: none;
  }
}

/* Table action column styling */
.actions-cell {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  min-width: 120px;
  padding: 8px;
}

/* Premium Action Buttons */
.edit-button {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
  display: flex;
  align-items: center;
  gap: 4px;
}

.filter-bulk {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.edit-button:hover {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
}

.delete-button {
  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.3);
  display: flex;
  align-items: center;
  gap: 4px;
}

.delete-button:hover {
  background: linear-gradient(135deg, #d32f2f 0%, #c62828 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.4);
}

/* Confirmation Modal Styles */
.confirmation-modal {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  width: 95%;
  max-width: 600px;
  min-width: 320px;
  overflow: hidden;
}

.confirmation-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.confirmation-modal .modal-header h3 {
  margin: 0;
  color: #e74c3c;
  font-size: 1.25rem;
}

.confirmation-modal .modal-body {
  padding: 20px;
}

.confirmation-modal .modal-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  gap: 10px;
}

.confirmation-modal .modal-footer .cancel-button {
  padding: 8px 20px !important;
  font-size: 13px !important;
  min-width: 90px;
  border-radius: 6px !important;
  flex: 0 0 auto;
}

.confirmation-modal .modal-footer .delete-button {
  padding: 8px 20px !important;
  font-size: 13px !important;
  min-width: 90px;
  border-radius: 6px !important;
  flex: 0 0 auto;
  justify-content: center;
}

.collection-delete-info {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 15px;
  margin: 15px 0;
  border-left: 4px solid #e74c3c;
}

.collection-delete-info p {
  margin: 5px 0;
  font-size: 15px;
}

.warning-text {
  color: #e74c3c;
  font-weight: 500;
  margin-top: 10px;
}

.cancel-button {
  background-color: #f8f9fa;
  color: #3c4043;
  border: 1px solid #dadce0;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.cancel-button:hover {
  background-color: #f1f3f4;
  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);
}

.cancel-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ===== Delete Confirmation Modal - Mobile Compact ===== */
@media (max-width: 768px) {
  .confirmation-modal {
    width: 92% !important;
    max-width: 92% !important;
    min-width: 0 !important;
    border-radius: 10px !important;
  }

  .confirmation-modal .modal-header {
    padding: 10px 14px !important;
  }

  .confirmation-modal .modal-header h3 {
    font-size: 1rem !important;
    margin: 0 !important;
  }

  .confirmation-modal .modal-close-button {
    font-size: 0.95rem !important;
    width: 22px !important;
    height: 22px !important;
  }

  .confirmation-modal .modal-body {
    padding: 12px 14px !important;
  }

  .confirmation-modal .modal-body p {
    font-size: 13px !important;
    margin-bottom: 8px !important;
  }

  .collection-delete-info {
    padding: 10px 12px !important;
    margin: 10px 0 !important;
    border-radius: 6px !important;
  }

  .collection-delete-info p {
    font-size: 12px !important;
    margin: 4px 0 !important;
  }

  .warning-text {
    font-size: 12px !important;
    margin-top: 8px !important;
    padding: 6px 10px !important;
    background-color: #fff3f3 !important;
    border-radius: 5px !important;
    border-left: 3px solid #e74c3c !important;
  }

  /* Buttons side-by-side and compact */
  .confirmation-modal .modal-footer {
    display: flex !important;
    flex-direction: row !important;
    justify-content: flex-end !important;
    gap: 8px !important;
    padding: 10px 14px !important;
  }

  .confirmation-modal .modal-footer .cancel-button {
    flex: 1 1 !important;
    padding: 8px 10px !important;
    font-size: 12px !important;
    border-radius: 6px !important;
    text-align: center !important;
    max-width: 48% !important;
  }

  .confirmation-modal .modal-footer .delete-button {
    flex: 1 1 !important;
    padding: 8px 10px !important;
    font-size: 12px !important;
    border-radius: 6px !important;
    justify-content: center !important;
    max-width: 48% !important;
  }
}

/* Edit Collection Modal */
.edit-collection-modal {
  max-width: 900px !important;
  width: 95%;
  min-width: 320px;
  max-height: 90vh;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.edit-collection-container {
  padding: 15px;
  background-color: #fff;
}

.edit-form-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.edit-form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.edit-text {
  font-weight: 500 !important;
  color: #000 !important;
}

.edit-form-input {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

/* Hide spinner buttons in Chrome, Safari, Edge */
.edit-form-input.no-spinners::-webkit-outer-spin-button,
.edit-form-input.no-spinners::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide spinner buttons in Firefox */
.edit-form-input.no-spinners {
  appearance: textfield;
}


.edit-form-input.error {
  border-color: #e74c3c;
}

.edit-input-error {
  color: #e74c3c;
  font-size: 12px;
  margin-top: 5px;
}

.edit-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.edit-form-button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-form-button.cancel {
  background-color: #f1f1f1;
  color: #333;
}

.edit-form-button.save {
  background-color: #27ae60;
  color: white;
}

.edit-form-button.cancel:hover {
  background-color: #e5e5e5;
}

.edit-form-button.save:hover {
  background-color: #219653;
}

.edit-form-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.edit-form-error {
  background-color: #ffebee;
  color: #c62828;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.calculation-results {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
  margin-top: 10px;
}

.calculation-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}

.calculation-item label {
  font-weight: 500;
  min-width: 70px;
}

.calculation-item span {
  font-weight: 600;
  color: #2c3e50;
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Edit Form Button - Preview Button */
.edit-form-button.preview {
  background-color: #00a67c;
  color: white;
}

.edit-form-button.preview:hover {
  background-color: #00916c;
}

/* Preview Modal Styles */
.preview-modal {
  width: 90%;
  max-width: 1200px;
  height: fit-content !important;
  max-height: 95vh;
  overflow-y: auto;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  min-height: auto !important;
}

.preview-modal .modal-body {
  padding: 20px 30px;
  overflow: visible;
}

.preview-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 20px 30px;
  border-top: 1px solid #e8eaed;
  background-color: #f8f9fa;
  gap: 15px;
}

.preview-header {
  background-color: #f0f7ff;
  padding: 15px 20px;
  border-radius: 6px;
  border-left: 4px solid #1976d2;
  margin-bottom: 20px;
}

.preview-info {
  font-size: 18px;
  color: #424242;
  margin: 0;
  line-height: 1.6;
}

.preview-table-container {
  overflow-x: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.preview-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 16px;
  line-height: 1.6;
}

.preview-table th,
.preview-table td {
  padding: 16px 24px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  white-space: nowrap;
}

/* Add alternating row colors for better readability */
.preview-table tbody tr:nth-child(even) {
  background-color: #f5f9ff;
}

.preview-table tbody tr:hover {
  background-color: #eaf0fb;
}

/* Improve column spacing with min-width */
.preview-table th {
  background-color: #f0f5fa;
  font-weight: 600;
  color: #444;
  position: relative;
  border-bottom: 2px solid #ddd;
  min-width: 100px;
  font-size: 17px;
}

/* Increase font size for table data */
.preview-table td {
  font-size: 16px;
  font-weight: 500;
}

/* Ensure certain columns have proper width */
.preview-table th:nth-child(1),
/* DateTime */
.preview-table td:nth-child(1) {
  min-width: 120px;
  max-width: 140px;
  width: fit-content;
}

.preview-table th:nth-child(2),
/* Date */
.preview-table td:nth-child(2) {
  min-width: 120px;
}

.preview-table th:nth-child(4),
/* Milk Type */
.preview-table td:nth-child(4) {
  min-width: 90px;
}

.preview-table th:nth-child(5),
/* Collection Time */
.preview-table td:nth-child(5) {
  min-width: 120px;
}

/* Numeric columns with right alignment */
.preview-table th:nth-child(3),
/* Weight */
.preview-table td:nth-child(3),
.preview-table th:nth-child(6),
/* Fat % */
.preview-table td:nth-child(6),
.preview-table th:nth-child(7),
/* CLR */
.preview-table td:nth-child(7),
.preview-table th:nth-child(8),
/* SNF % */
.preview-table td:nth-child(8),
.preview-table th:nth-child(9),
/* Fat KG */
.preview-table td:nth-child(9),
.preview-table th:nth-child(10),
/* SNF KG */
.preview-table td:nth-child(10),
.preview-table th:nth-child(11),
/* Fat Rate */
.preview-table td:nth-child(11),
.preview-table th:nth-child(12),
/* SNF Rate */
.preview-table td:nth-child(12),
.preview-table th:nth-child(13),
/* Base SNF % */
.preview-table td:nth-child(13),
.preview-table th:nth-child(14),
/* Milk Rate */
.preview-table td:nth-child(14) {
  text-align: right;
  min-width: 100px;
  padding-right: 30px;
}

/* Special styling for monetary values */
.preview-table td:nth-child(15) {
  font-weight: 600;
  color: #2e7d32;
  font-size: 16px;
}

/* Add more visual separation between groups of columns */
.preview-table th:nth-child(5),
/* After Collection Time */
.preview-table td:nth-child(5) {
  border-right: 2px solid #ddd;
}

.preview-table th:nth-child(8),
/* After SNF % */
.preview-table td:nth-child(8) {
  border-right: 2px solid #ddd;
}

.preview-table th:nth-child(12),
/* After SNF Rate */
.preview-table td:nth-child(12) {
  border-right: 2px solid #ddd;
}

.preview-table th:nth-child(13),
/* After Base SNF % */
.preview-table td:nth-child(13) {
  border-right: 2px solid #ddd;
}

.confirm-button,
.cancel-button {
  margin-left: 12px;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.2s;
  font-size: 16px;
  gap: 8px;
}

.cancel-button {
  background: #f8f9fa;
  color: #3c4043;
  border: 1px solid #dadce0;
}

.cancel-button:hover {
  background: #f1f3f4;
  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);
}

.confirm-button {
  background: #1a73e8;
  color: white;
}

.confirm-button:hover {
  background: #1765cc;
  box-shadow: 0 1px 3px rgba(26, 115, 232, 0.4);
}

.confirm-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: #4d90fe;
  box-shadow: none;
}

/* Responsive styles for preview modal */
@media (max-width: 1200px) {
  .preview-modal {
    max-width: 95%;
    margin: 15px;
  }

  .preview-table {
    min-width: 800px;
  }
}

@media (max-width: 768px) {
  .preview-modal {
    width: 95% !important;
    height: fit-content !important;
    max-height: 85vh !important;
    margin: 5px !important;
    min-height: auto !important;
  }

  .preview-modal .modal-header {
    padding: 12px 16px !important;
  }

  .preview-modal .modal-header h2 {
    font-size: 1.2rem !important;
    margin: 0 !important;
  }

  .preview-modal .close-modal-button {
    font-size: 1.1rem !important;
    width: 24px !important;
    height: 24px !important;
  }

  .preview-modal .modal-body {
    padding: 10px 12px !important;
    overflow: visible !important;
  }

  .preview-header {
    padding: 8px 12px !important;
    margin-bottom: 12px !important;
    border-left-width: 3px !important;
  }

  .preview-info {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }

  .preview-table-container {
    margin-top: 8px !important;
  }

  .preview-table th,
  .preview-table td {
    padding: 6px 8px !important;
    font-size: 11px !important;
  }

  .modal-footer-preview {
    flex-direction: row !important;
    justify-content: space-between !important;
    gap: 8px !important;
    padding: 10px 12px !important;
  }

  .cancel-button-preview,
  .confirm-button-preview,
  .rate-settings-btn-preview {
    flex: 1 1 !important;
    width: auto !important;
    justify-content: center !important;
    padding: 8px 10px !important;
    font-size: 11px !important;
    white-space: nowrap !important;
    gap: 4px !important;
  }
}

/* ===== Edit Collection Modal - Mobile Compact ===== */
@media (max-width: 768px) {
  .edit-collection-modal {
    max-width: 98% !important;
    width: 98% !important;
    max-height: 92vh !important;
    margin: 4% auto !important;
    border-radius: 10px !important;
    overflow-y: auto !important;
  }

  .edit-collection-modal .modal-header {
    padding: 10px 14px !important;
  }

  .edit-collection-modal .modal-header h2 {
    font-size: 1rem !important;
    margin: 0 !important;
  }

  .edit-collection-modal .modal-close-button {
    font-size: 1rem !important;
    width: 22px !important;
    height: 22px !important;
  }

  .edit-collection-container {
    padding: 10px 12px !important;
  }

  /* 2-column grid on mobile for compactness */
  .edit-form-row {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 8px !important;
    margin-bottom: 8px !important;
  }

  .edit-form-group {
    flex: unset !important;
  }

  .edit-text {
    font-size: 11px !important;
    margin-bottom: 3px !important;
    display: block !important;
  }

  .edit-form-input {
    padding: 7px 8px !important;
    font-size: 12px !important;
    border-radius: 5px !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  /* Supplier row — full width since it has the select button */
  .edit-form-row:first-of-type {
    grid-template-columns: 1fr !important;
  }

  .customer-select-container {
    gap: 6px !important;
  }

  .customer-select-button {
    padding: 7px 10px !important;
    font-size: 11px !important;
    white-space: nowrap !important;
    flex-shrink: 0 !important;
  }

  /* Calculation results - compact 3-column row */
  .calculation-results {
    flex-direction: row !important;
    flex-wrap: wrap !important;
    padding: 8px 10px !important;
    gap: 6px !important;
    margin-top: 6px !important;
  }

  .calculation-item {
    flex-direction: column !important;
    align-items: flex-start !important;
    flex: 1 1 !important;
    min-width: 70px !important;
    gap: 2px !important;
  }

  .calculation-item label {
    font-size: 10px !important;
    color: #6b7280 !important;
    min-width: unset !important;
  }

  .calculation-item span {
    font-size: 12px !important;
    font-weight: 600 !important;
  }

  /* Action buttons side by side */
  .edit-form-actions {
    display: flex !important;
    flex-direction: row !important;
    gap: 8px !important;
    margin-top: 10px !important;
  }

  .edit-form-button {
    flex: 1 1 !important;
    padding: 9px 10px !important;
    font-size: 12px !important;
    border-radius: 6px !important;
    justify-content: center !important;
  }

  .edit-input-error {
    font-size: 10px !important;
    margin-top: 2px !important;
  }
}

@media (max-width: 479px) {
  .preview-modal .modal-header h2 {
    font-size: 1rem !important;
  }

  .preview-info {
    font-size: 11px !important;
  }

  .preview-table th,
  .preview-table td {
    padding: 4px 6px !important;
    font-size: 10px !important;
  }

  .cancel-button-preview,
  .confirm-button-preview,
  .rate-settings-btn-preview {
    padding: 6px 8px !important;
    font-size: 10px !important;
    gap: 2px !important;
  }
}

/* Customer selection in edit form */
.customer-select-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.customer-select-button {
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s ease;
}

.customer-select-button:hover {
  background-color: #2980b9;
}

.customer-select-container .edit-form-input {
  flex: 1 1;
}

/* Make customer modal appear above other modals */
.modal-overlay .customer-modal {
  z-index: 1010;
}

/* Modal header styling */
.preview-modal .modal-header {
  padding: 22px 28px;
  border-bottom: 1px solid #e8eaed;
  background-color: #f8f9fa;
}

.preview-modal .modal-header h2 {
  margin: 0;
  font-size: 1.7rem;
  color: #1976d2;
}

/* Preview modal footer styling */
.modal-footer-preview {
  display: flex;
  justify-content: flex-end;
  padding: 20px 30px;
  border-top: 1px solid #e8eaed;
  background-color: #f8f9fa;
  gap: 8px;
}

/* Preview modal buttons - smaller on desktop */
.cancel-button-preview,
.confirm-button-preview {
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.2s;
  gap: 8px;
}

.cancel-button-preview {
  background: #f8f9fa;
  color: #3c4043;
  border: 1px solid #dadce0;
}

.cancel-button-preview:hover {
  background: #f1f3f4;
  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);
  transform: translateY(-1px);
}

.confirm-button-preview {
  background: #2563eb;
  color: white;
}

.confirm-button-preview:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
}

.confirm-button-preview:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.collections-table td.customer-name-cell,
.collections-table td:nth-child(3) {
  text-align: left !important;
}

/* Collection Summary Statistics */
.collection-summary-stats {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 0;
  margin: 24px 0;
  overflow: hidden;
  border: 1px solid #e8eaed;
}

.summary-header {
  background-color: #f0f7ff;
  padding: 16px 20px;
  border-bottom: 1px solid #e8eaed;
  border-left: 4px solid #1976d2;
}

.summary-header h3 {
  margin: 0;
  color: #1976d2;
  font-size: 18px;
  font-weight: 600;
}

.stats-container {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  gap: 20px;
}

.stat-item {
  flex: 1 1;
  min-width: 180px;
  background-color: #f9fafc;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  border: 1px solid #eef1f6;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.stat-label {
  font-size: 14px;
  color: #5f6368;
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 22px;
  font-weight: 600;
  color: #202124;
}

.stat-item:nth-child(1) .stat-value {
  color: #4338ca;
}

.stat-item:nth-child(2) .stat-value {
  color: #166534;
}

.stat-item:nth-child(3) .stat-value {
  color: #9a3412;
}

.stat-item:nth-child(4) .stat-value {
  color: #0369a1;
}

.stat-item:nth-child(5) .stat-value {
  color: #6b21a8;
}

.stat-item:nth-child(6) .stat-value {
  color: #047857;
}

.stat-item:nth-child(7) .stat-value {
  color: #b45309;
}

.stat-footer {
  background-color: #f8f9fa;
  padding: 16px 20px;
  border-top: 1px solid #e8eaed;
  text-align: right;
  font-size: 15px;
  color: #424242;
}

.final-amount {
  font-size: 20px;
  font-weight: 700;
  color: #1e8e3e;
}

@media (max-width: 768px) {

  /* Header */
  .collections-header {
    padding: 0.75rem 1rem;
  }

  .collections-header h1 {
    font-size: 1.1rem;
  }

  .back-button-viewCollection,
  .logout-button {
    font-size: 0.75rem;
    gap: 0.3rem;
  }

  .back-button-viewCollection svg,
  .logout-button svg {
    font-size: 0.8rem;
  }

  /* Content */
  .collections-content {
    padding: 1rem;
  }

  .collections-filters {
    margin-bottom: 2rem;
    margin-top: 3rem;
  }

  /* Search */
  .search-wrapper {
    margin-bottom: 0.75rem;
  }

  .search-input {
    padding: 0.6rem 2.5rem 0.6rem 2.5rem;
    font-size: 0.85rem;
  }

  .search-icon,
  .clear-search-icon {
    font-size: 0.9rem;
  }

  /* Filter buttons */
  .filter-options {
    gap: 0.5rem;
    padding: 0.25rem 0;
    display: flex;
    flex-direction: column;
  }

  .filter-button {
    padding: 0.65rem 0.75rem;
    font-size: 0.8rem;
    gap: 5px;
    justify-content: center;
    width: 100%;
  }

  .filter-button svg {
    font-size: 0.9rem;
  }

  /* Active filters summary */
  .active-filters-summary {
    padding: 0.75rem;
    margin-top: 0.75rem;
    font-size: 0.8rem;
  }

  .active-filters-summary p {
    margin-bottom: 0.5rem;
  }

  .clear-filter-button {
    padding: 0.35rem 0.6rem;
    font-size: 0.75rem;
  }

  /* Collections table */
  .collections-table-container {
    margin: 1rem 0;
  }

  .collections-table {
    font-size: 0.7rem;
  }

  .collections-table th,
  .collections-table td {
    padding: 0.5rem 0.4rem;
  }

  /* Summary stats */
  .collection-summary-stats {
    margin: 1rem 0;
  }

  .summary-header {
    padding: 0.75rem 1rem;
  }

  .summary-header h3 {
    font-size: 0.95rem;
  }

  .stats-container {
    flex-direction: column;
    padding: 0.75rem;
    gap: 0.75rem;
  }

  .stat-item {
    width: 100%;
    min-width: unset;
    padding: 0.75rem;
  }

  .stat-label {
    font-size: 0.75rem;
    margin-bottom: 0.4rem;
  }

  .stat-value {
    font-size: 1rem;
  }

  .stat-footer {
    padding: 0.75rem 1rem;
    font-size: 0.8rem;
  }

  .final-amount {
    font-size: 1rem;
  }

  /* No collections message */
  .no-collections {
    padding: 1.5rem 1rem;
    font-size: 0.85rem;
  }

  /* Loading */
  .loading-container {
    padding: 1.5rem 1rem;
  }

  .loading-container p {
    font-size: 0.85rem;
  }

  /* Error message */
  .error-message {
    padding: 1rem;
    font-size: 0.85rem;
  }

  .error-message button {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }

  /* Success message */
  .success-message {
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
  }

  .success-message p {
    font-size: 0.85rem;
  }
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 12px 20px;
  margin: 10px 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-message p {
  margin: 0;
  font-size: 16px;
}

/* Bulk Update Modal Styling */
.bulk-update-button {
  background: linear-gradient(135deg, #28a745, #20c997) !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3) !important;
}

.bulk-update-button:hover {
  background: linear-gradient(135deg, #218838, #1ea085) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.4) !important;
}

.bulk-update-button:active {
  transform: translateY(0) !important;
}

/* Enhanced Filter Info Section */
.filter-info {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 25px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.filter-info p {
  margin: 8px 0;
  font-size: 14px;
  color: #495057;
  display: flex;
  align-items: center;
}

.filter-info p:first-child {
  font-size: 16px;
  color: #007bff;
  font-weight: 600;
  margin-bottom: 12px;
}

.filter-info p strong {
  color: #212529;
  margin-right: 8px;
}

/* Enhanced Form Groups */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.3s ease;
  background-color: #fff;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  transform: translateY(-1px);
}

.form-group input:hover {
  border-color: #adb5bd;
}

/* Enhanced Modal Actions */
.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin: 25px 0 0 0;
  padding-top: 20px;
  border-top: 1px solid #dee2e6;
}

.cancel-button,
.submit-button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
  justify-content: center;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
  border: 2px solid #6c757d;
}

.cancel-button:hover {
  background-color: #5a6268;
  border-color: #545b62;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(108, 117, 125, 0.3);
}

.submit-button {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: 2px solid #007bff;
}

.submit-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #0056b3, #004085);
  border-color: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

.submit-button:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Enhanced Error Message */
.error-message {
  background: linear-gradient(135deg, #f8d7da, #f5c6cb);
  border: 1px solid #dc3545;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 20px;
  color: #721c24;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.1);
}

/* Enhanced Modal Header */
.modal-header h2 {
  color: #212529;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-actions {
    flex-direction: column;
  }

  .cancel-button,
  .submit-button {
    width: 100%;
  }

  .filter-info {
    padding: 15px;
  }

  .form-group input {
    padding: 10px 14px;
  }
}

/* Rate Settings Modal Styles */
.rate-settings-modal {
  background: white;
  border-radius: 8px;
  width: 95%;
  max-width: 600px;
  min-width: 320px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.rate-settings-modal .modal-body {
  padding: 24px 28px;
}

.rate-settings-modal .change-rates-section {
  margin-bottom: 24px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #f8f9fa;
}

.rate-settings-modal .change-rates-section h4 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.rate-settings-modal .change-rates-section .section-description {
  margin: 0 0 16px 0;
  color: #666;
  font-size: 14px;
}

.rate-settings-modal .option-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.rate-settings-modal .option-btn {
  flex: 1 1;
  min-width: 80px;
  padding: 10px 12px;
  border: 2px solid #ddd;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 500;
}

.rate-settings-modal .option-btn:hover {
  border-color: #1976d2;
  background: #f5f9ff;
}

.rate-settings-modal .option-btn.active {
  border-color: #1976d2 !important;
  background: #1976d2 !important;
  color: white !important;
}

/* Rate Settings Button */
.rate-settings-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.rate-settings-btn:hover {
  background-color: #1565c0;
}

.rate-settings-btn svg {
  font-size: 14px;
}

/* Preview modal footer with left-aligned rate settings */
.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid #e8eaed;
  background-color: #f8f9fa;
}

.modal-footer .rate-settings-btn {
  order: -1;
  /* Move rate settings button to the left */
  margin-right: auto;
  /* Push it to the far left */
}

.modal-footer .cancel-button {
  margin-left: auto;
  /* Keep cancel on the right */
}

.modal-footer .confirm-button {
  margin-left: 12px;
  /* Space between cancel and confirm */
}

/* Bulk Update Modal Styles */
.bulk-update-modal {
  max-width: 700px;
  width: 95%;
  min-width: 320px;
}

.bulk-update-modal .modal-content {
  padding: 0;
}

.bulk-update-modal .modal-body {
  padding: 24px;
  display: flex;
  gap: 32px;
}

.bulk-update-modal .left-column {
  flex: 1 1;
}

.bulk-update-modal .right-column {
  flex: 1 1;
}

.bulk-update-summary {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 5px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  margin-bottom: 5px;
  align-items: flex-start;
}

.bulk-update-summary p {
  margin: 5px 0;
  color: #495057;
  font-size: 15px !important;
  /* line-height: 1.5; */
}



.bulk-update-summary p strong {
  color: #212529;
}

.method-summary {
  display: flex;
  gap: 5px;
}

.bulk-update-field {
  display: flex;
}

.bulk-update-field .form-input:disabled {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  border-color: #dee2e6 !important;
  cursor: not-allowed !important;
  opacity: 0.7 !important;
}

.bulk-update-field .form-input:disabled:hover {
  background-color: #f8f9fa !important;
  border-color: #dee2e6 !important;
  transform: none !important;
  box-shadow: none !important;
}

.bulk-update-field label {
  font-weight: 500;
  color: #495057;
  font-size: 14px;
  margin-bottom: 4px;
}

.bulk-update-field label:has(+ .form-input:disabled) {
  color: #6c757d !important;
}

.bulk-update-field .field-hint {
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
  display: block;
}

.bulk-update-form-view {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bulk-update-form-view .form-group {
  display: flex;
  flex-direction: column;
}

.bulk-update-form-view .form-group label {
  font-weight: 500;
  color: #495057;
  font-size: 14px;
  margin-bottom: 4px;
}

.bulk-update-form-view .form-input {
  padding: 12px 16px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: #fff;
}

.bulk-update-form-view .form-input:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.bulk-update-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

.bulk-update-modal .cancel-button {
  padding: 10px 20px;
  border: 1px solid #6c757d;
  background-color: #fff;
  color: #6c757d;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
}

.bulk-update-modal .cancel-button:hover {
  background-color: #e9ecef;
  border-color: #5a6268;
}

.bulk-update-modal .update-button {
  padding: 10px 20px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
  display: flex;
  align-items: center;
  gap: 8px;
}

.bulk-update-modal .update-button:hover {
  background-color: #0056b3;
}

.bulk-update-modal .update-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Modal Overlay for Pro Rata */
.modal-overlay-prorata {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(2px);
  width: 100%;
  height: 100%;
}

/* Pro Rata Confirmation Modal Styles */
.prorata-confirmation-modal {
  width: 90%;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.prorata-confirmation-modal .modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.prorata-confirmation-modal .modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #1976d2;
  font-weight: 600;
}

.prorata-confirmation-modal .modal-body {
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.prorata-confirmation-modal .confirmation-summary {
  background-color: #e7f3ff;
  border-left: 4px solid #1976d2;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.prorata-confirmation-modal .confirmation-summary p {
  margin: 8px 0;
  color: #333;
  font-size: 14px;
}

.prorata-confirmation-modal .confirmation-summary p:first-child {
  margin-top: 0;
  font-weight: 600;
  color: #1976d2;
}

.prorata-confirmation-modal .confirmation-table-wrapper {
  overflow-x: auto;
  overflow-y: visible;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin: 20px 0;
  flex: 1 1;
  min-height: 0;
}

.prorata-confirmation-modal .confirmation-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.prorata-confirmation-modal .confirmation-table thead {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.prorata-confirmation-modal .confirmation-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  border-right: 1px solid #dee2e6;
}

.prorata-confirmation-modal .confirmation-table th:last-child {
  border-right: none;
}

.prorata-confirmation-modal .confirmation-table td {
  padding: 12px;
  border-right: 1px solid #dee2e6;
  color: #555;
}

.prorata-confirmation-modal .confirmation-table td:last-child {
  border-right: none;
}

.prorata-confirmation-modal .confirmation-table tbody tr {
  border-bottom: 1px solid #e9ecef;
}

.prorata-confirmation-modal .confirmation-table tbody tr:hover {
  background-color: #f8f9fa;
}

.prorata-confirmation-modal .confirmation-table td.highlight-new {
  background-color: #fff9e6;
  font-weight: 600;
  color: #d97706;
}

.prorata-confirmation-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e9ecef;
  background-color: #f8f9fa;
  flex-shrink: 0;
}

.prorata-confirmation-modal .cancel-button {
  padding: 10px 24px;
  background-color: #ffffff;
  color: #333;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.prorata-confirmation-modal .cancel-button:hover:not(:disabled) {
  background-color: #f8f9fa;
  border-color: #adb5bd;
}

.prorata-confirmation-modal .confirm-button {
  padding: 10px 24px;
  background-color: #1976d2;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
}

.prorata-confirmation-modal .confirm-button:hover:not(:disabled) {
  background-color: #1565c0;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

.prorata-confirmation-modal .confirm-button:disabled {
  background-color: #90caf9;
  cursor: not-allowed;
}

.prorata-confirmation-modal .cancel-button:disabled {
  color: #adb5bd;
  border-color: #dee2e6;
  cursor: not-allowed;
}

/* Bulk Update Confirmation Modal Styles */
.confirmation-modal {
  width: 90%;
  max-width: 1400px;
  height: 85vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.confirmation-modal .modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.confirmation-modal .modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #1976d2;
  font-weight: 600;
}

.confirmation-modal .modal-body {
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.confirmation-summary {
  background-color: #e7f3ff;
  border-left: 4px solid #1976d2;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.confirmation-summary p {
  margin: 8px 0;
  color: #333;
  font-size: 14px;
}

.confirmation-summary p:first-child {
  margin-top: 0;
  font-weight: 600;
  color: #1976d2;
}

.confirmation-table-wrapper {
  overflow-x: auto;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin: 20px 0;
  flex: 1 1;
  min-height: 0;
}

.confirmation-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.confirmation-table thead {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.confirmation-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  border-right: 1px solid #dee2e6;
}

.confirmation-table th:last-child {
  border-right: none;
}

.confirmation-table td {
  padding: 12px;
  border-right: 1px solid #dee2e6;
  color: #555;
}

.confirmation-table td:last-child {
  border-right: none;
}

.confirmation-table tbody tr {
  border-bottom: 1px solid #e9ecef;
}

.confirmation-table tbody tr:hover {
  background-color: #f8f9fa;
}

.confirmation-table td.highlight-new {
  background-color: #fff9e6;
  font-weight: 600;
  color: #d97706;
}

.confirmation-modal .modal-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px;
  border-top: 1px solid #e9ecef;
  background-color: #f8f9fa;
  flex-shrink: 0;
}

.confirmation-modal .cancel-button {
  padding: 10px 24px;
  background-color: #ffffff;
  color: #333;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.confirmation-modal .cancel-button:hover:not(:disabled) {
  background-color: #f8f9fa;
  border-color: #adb5bd;
}

.confirmation-modal .confirm-button {
  padding: 10px 24px;
  background-color: #1976d2;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
}

.confirmation-modal .confirm-button:hover:not(:disabled) {
  background-color: #1565c0;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

.confirmation-modal .confirm-button:disabled {
  background-color: #90caf9;
  cursor: not-allowed;
}

.confirmation-modal .cancel-button:disabled {
  color: #adb5bd;
  border-color: #dee2e6;
  cursor: not-allowed;
}

/* Responsive styles for confirmation modal */
@media (max-width: 1024px) {
  .confirmation-modal {
    max-width: 90%;
    max-height: 90vh;
  }

  .confirmation-table {
    font-size: 12px;
  }

  .confirmation-table th,
  .confirmation-table td {
    padding: 10px;
  }
}

@media (max-width: 768px) {
  .confirmation-modal {
    width: 95%;
    max-height: 95vh;
    margin: 10px;
  }

  .confirmation-modal .modal-header {
    padding: 16px;
  }

  .confirmation-modal .modal-header h2 {
    font-size: 1.25rem;
  }

  .confirmation-modal .modal-body {
    padding: 16px;
  }

  .confirmation-table {
    font-size: 11px;
  }

  .confirmation-table th,
  .confirmation-table td {
    padding: 8px;
  }

  .confirmation-modal .modal-footer {
    padding: 12px 16px;
    flex-direction: column;
  }

  .confirmation-modal .cancel-button,
  .confirmation-modal .confirm-button {
    width: 100%;
    justify-content: center;
  }
}

/* Rate Chart Modal Styles */
.rate-chart-modal {
  max-width: 600px;
  width: 90%;
}

.rate-chart-container {
  padding: 20px;
}

.rate-chart-info h3,
.rate-chart-formula h3 {
  color: #2c3e50;
  margin-bottom: 15px;
  font-size: 18px;
  border-bottom: 2px solid #3498db;
  padding-bottom: 8px;
}

.rate-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
}

.rate-info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #3498db;
}

.rate-info-item label {
  font-weight: 600;
  color: #555;
  margin: 0;
}

.rate-info-item span {
  font-weight: 500;
  color: #2c3e50;
  font-size: 16px;
}

.formula-box {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  border-left: 4px solid #e74c3c;
}

.formula-box p {
  margin: 0 0 10px 0;
  color: #555;
}

.formula-box code {
  display: block;
  background-color: #2c3e50;
  color: #ecf0f1;
  padding: 12px;
  border-radius: 6px;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 15px;
  word-break: break-all;
}

.rate-chart-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  width: 100%;
  justify-content: center;
}

.rate-chart-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.rate-chart-button:active {
  transform: translateY(0);
}

.rate-chart-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 768px) {
  .rate-chart-modal {
    width: 95%;
    max-width: none;
    margin: 10px;
  }

  .rate-info-grid {
    grid-template-columns: 1fr;
  }

  .rate-info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .formula-box code {
    font-size: 12px;
    padding: 10px;
  }
}

/* Bulk Update Modal Footer Buttons */
.modal-footer-bulk-update {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #e9ecef;
  background-color: #f8f9fa;
}

.cancel-button-bulk-update {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
  color: #6c757d;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 100px;
  justify-content: center;
}

.cancel-button-bulk-update:hover:not(:disabled) {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
  border-color: #adb5bd;
  color: #495057;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.cancel-button-bulk-update:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.confirm-button-bulk-update {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: 1px solid #28a745;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 140px;
  justify-content: center;
}

.confirm-button-bulk-update:hover:not(:disabled) {
  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);
  border-color: #1e7e34;
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.3);
}

.confirm-button-bulk-update:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Mobile responsive for bulk update buttons */
@media (max-width: 768px) {
  .modal-footer-bulk-update {
    display: flex !important;
    flex-direction: row !important;
    gap: 8px !important;
    padding: 8px !important;
    align-items: center !important;
    justify-content: space-between !important;
    flex-wrap: nowrap !important;
  }

  .cancel-button-bulk-update,
  .confirm-button-bulk-update {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: clip !important;
    flex: 1 1 !important;
    width: 50% !important;
    min-width: 0 !important;
    padding: 8px 4px !important;
    font-size: 10.5px !important;
    gap: 4px !important;
    box-sizing: border-box !important;
  }
}

@media (max-width: 480px) {
  .modal-footer-bulk-update {
    padding: 6px !important;
    gap: 4px !important;
  }

  .cancel-button-bulk-update,
  .confirm-button-bulk-update {
    padding: 8px 2px !important;
    font-size: 9.5px !important;
    gap: 2px !important;
  }

  .cancel-button-bulk-update svg,
  .confirm-button-bulk-update svg {
    font-size: 10px !important;
  }
}

/* Pro Rata Shift Right Container - Desktop Only */
@media (min-width: 1025px) {
  .pro-shift-right {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 12px;
    margin-left: auto;
  }
}

/* Mobile and Tablet - Keep default layout */
@media (max-width: 1024px) {
  .pro-shift-right {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }
}

/* Milk Rate Preview Modal - Input and Select Placeholder Styles */
.preview-modal input::placeholder,
.preview-modal select::placeholder,
.collections-container input::placeholder,
.collections-container select::placeholder,
.dashboard-container input::placeholder,
.dashboard-container select::placeholder {
  color: #9e9e9e !important;
  opacity: 1 !important;
}

.preview-modal input::-webkit-input-placeholder,
.preview-modal select::-webkit-input-placeholder,
.collections-container input::-webkit-input-placeholder,
.collections-container select::-webkit-input-placeholder,
.dashboard-container input::-webkit-input-placeholder,
.dashboard-container select::-webkit-input-placeholder {
  color: #9e9e9e !important;
  opacity: 1 !important;
}

.preview-modal input::-moz-placeholder,
.preview-modal select::-moz-placeholder,
.collections-container input::-moz-placeholder,
.collections-container select::-moz-placeholder,
.dashboard-container input::-moz-placeholder,
.dashboard-container select::-moz-placeholder {
  color: #9e9e9e !important;
  opacity: 1 !important;
}

.preview-modal input:-ms-input-placeholder,
.preview-modal select:-ms-input-placeholder,
.collections-container input:-ms-input-placeholder,
.collections-container select:-ms-input-placeholder,
.dashboard-container input:-ms-input-placeholder,
.dashboard-container select:-ms-input-placeholder {
  color: #9e9e9e !important;
  opacity: 1 !important;
}

/* Final Submit Confirmation Modal Styles */
.bulk-final-confirmation-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2), 0 8px 20px rgba(0, 0, 0, 0.15);
  max-width: 500px;
  width: 90%;
  max-height: 85vh;
  overflow-y: auto;
  position: relative;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header-confirmation {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  padding: 1rem;
  text-align: center;
  position: relative;
}

.modal-header-confirmation h2 {
  margin: 0;
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.modal-body-confirmation-card {
  padding: 0;
  background: white;
}

.bulk-final-confirmation-content {
  padding: 1.2rem;
  text-align: center;
}

.bulk-final-confirmation-icon {
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
}

.bulk-final-confirmation-icon svg {
  font-size: 2.5rem;
  color: #dc3545;
  animation: pulse 2s infinite;
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}

.bulk-final-confirmation-title {
  color: #dc3545;
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 0.8rem 0;
  line-height: 1.3;
}

.bulk-final-confirmation-text {
  color: #495057;
  font-size: 0.95rem;
  margin: 0 0 1rem 0;
  line-height: 1.4;
}

.bulk-final-confirmation-changes {
  list-style: none;
  padding: 1rem;
  margin: 0 0 1rem 0;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #0056b3;
  text-align: left;
}

.bulk-final-confirmation-changes li {
  margin-bottom: 0.5rem;
  color: #495057;
  font-size: 0.9rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.bulk-final-confirmation-changes li:last-child {
  margin-bottom: 0;
}

.bulk-final-confirmation-changes strong {
  color: #212529;
  font-weight: 600;
}

.bulk-final-confirmation-warning {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border: 1px solid #90caf9;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  text-align: left;
}

.bulk-final-confirmation-warning strong {
  color: #1565c0;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.3rem;
}

.bulk-final-confirmation-warning p {
  color: #1565c0;
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.4;
}

.bulk-final-confirmation-question {
  color: #212529;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.3;
}

.bulk-final-confirmation-footer {
  padding: 1rem;
  background: #f8f9fa;
  border-top: 1px solid #dee2e6;
  display: flex;
  gap: 0.8rem;
  justify-content: center;
  flex-wrap: wrap;
}

.bulk-cancel-button-confirmation,
.bulk-submit-button-confirmation {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 120px;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.bulk-cancel-button-confirmation {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  color: white;
  border: 1px solid #5a6268;
}

.bulk-cancel-button-confirmation:hover:not(:disabled) {
  background: linear-gradient(135deg, #5a6268 0%, #495057 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.3);
}

.bulk-submit-button-confirmation {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  color: white;
  border: 1px solid #004085;
}

.bulk-submit-button-confirmation:hover:not(:disabled) {
  background: linear-gradient(135deg, #004085 0%, #003680 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 86, 179, 0.4);
}

.bulk-cancel-button-confirmation:disabled,
.bulk-submit-button-confirmation:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.bulk-submit-button-confirmation svg.fa-spinner {
  animation: spin 1s linear infinite;
}

.bulk-submit-button-confirmation svg.fa-check {
  animation: none !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .bulk-final-confirmation-modal {
    max-width: 95%;
    margin: 1rem;
    border-radius: 12px;
  }

  .modal-header-confirmation {
    padding: 1.2rem;
  }

  .modal-header-confirmation h2 {
    font-size: 1.3rem;
  }

  .bulk-final-confirmation-content {
    padding: 1.5rem;
  }

  .bulk-final-confirmation-icon svg {
    font-size: 3rem;
  }

  .bulk-final-confirmation-title {
    font-size: 1.2rem;
  }

  .bulk-final-confirmation-text {
    font-size: 1rem;
  }

  .bulk-final-confirmation-changes {
    padding: 1.2rem;
  }

  .bulk-final-confirmation-changes li {
    font-size: 0.95rem;
  }

  .bulk-final-confirmation-warning {
    padding: 1.2rem;
  }

  .bulk-final-confirmation-warning strong {
    font-size: 0.95rem;
  }

  .bulk-final-confirmation-warning p {
    font-size: 0.9rem;
  }

  .bulk-final-confirmation-question {
    font-size: 1.1rem;
  }

  .bulk-final-confirmation-footer {
    padding: 1.2rem;
    flex-direction: column;
    gap: 0.8rem;
  }

  .bulk-cancel-button-confirmation,
  .bulk-submit-button-confirmation {
    width: 100%;
    max-width: 280px;
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .bulk-final-confirmation-modal {
    max-width: 98%;
    margin: 0.5rem;
    border-radius: 10px;
  }

  .modal-header-confirmation {
    padding: 1rem;
  }

  .modal-header-confirmation h2 {
    font-size: 1.2rem;
  }

  .bulk-final-confirmation-content {
    padding: 1rem;
  }

  .bulk-final-confirmation-icon svg {
    font-size: 2.5rem;
  }

  .bulk-final-confirmation-title {
    font-size: 1.1rem;
  }

  .bulk-final-confirmation-text {
    font-size: 0.95rem;
  }

  .bulk-final-confirmation-changes {
    padding: 1rem;
  }

  .bulk-final-confirmation-changes li {
    font-size: 0.9rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.3rem;
  }

  .bulk-final-confirmation-warning {
    padding: 1rem;
  }

  .bulk-final-confirmation-warning strong {
    font-size: 0.9rem;
  }

  .bulk-final-confirmation-warning p {
    font-size: 0.85rem;
  }

  .bulk-final-confirmation-question {
    font-size: 1rem;
  }

  .bulk-final-confirmation-footer {
    padding: 1rem;
  }

  .bulk-cancel-button-confirmation,
  .bulk-submit-button-confirmation {
    padding: 0.875rem;
    font-size: 0.95rem;
  }
}

/* Time selection dropdown options cursor fix */
.collections-container select,
.collections-container select option,
.collections-container select option:hover,
.collections-container select option:focus {
  cursor: pointer !important;
}

/* Additional fix for all select elements in collections container */
.collections-container select {
  cursor: pointer !important;
}

.collections-container select option {
  cursor: pointer !important;
}

/* Global fix for all select options across the application */
select option {
  cursor: pointer !important;
}

/* More specific targeting for time period dropdown */
select[name="shiftFilter"] option,
select[id*="shift"] option,
select option[value="morning"],
select option[value="evening"],
select option[value="all"] {
  cursor: pointer !important;
}

/* Make the entire select box clickable with hand pointer */
.collections-container select:hover,
.collections-container select:focus {
  cursor: pointer !important;
}

/* Ensure all select elements have hand pointer on hover */
select:hover,
select:focus {
  cursor: pointer !important;
}

/* Make the entire shift filter dropdown clickable */
.shift-filter-dropdown {
  cursor: pointer !important;
  position: relative;
  display: inline-flex;
  align-items: center;
}

.shift-filter-dropdown:hover {
  cursor: pointer !important;
}

.shift-filter-dropdown .shift-filter-select {
  cursor: pointer !important;
  position: relative;
  z-index: 1;
  /* Make select fill the entire button area */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: none;
  background: transparent;
}

/* Ensure the entire dropdown area is clickable */
.shift-filter-dropdown:hover .shift-filter-select {
  cursor: pointer !important;
}

/* Make sure the shift filter dropdown button is fully clickable */
.filter-button.shift-filter-dropdown {
  cursor: pointer !important;
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.filter-button.shift-filter-dropdown:hover {
  cursor: pointer !important;
}

/* Ensure any element within the shift filter dropdown has pointer cursor */
.filter-button.shift-filter-dropdown * {
  cursor: pointer !important;
}

.filter-button.shift-filter-dropdown:hover * {
  cursor: pointer !important;
}

/* Style for the shift filter text */
.shift-filter-text {
  pointer-events: none;
  /* Allow clicks to pass through to the select element */
  z-index: 0;
  position: relative;
  font-size: 0.9rem;
  font-weight: 600;
  color: #2c3e50;
}

/* Bulk Edit responsive summary layout */
.bulk-edit-summary {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

@media (max-width: 600px) {
  .bulk-edit-summary {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 4px !important;
    width: 100% !important;
  }
  .bulk-edit-summary-divider {
    display: none !important;
  }
}

/* Make supplier ID small on mobile screens */
@media (max-width: 768px) {
  .customer-id-span {
    font-size: 12px !important;
    font-weight: 500 !important;
  }
}
/* Animal Filter CSS */
.animal-filter-dropdown {
  cursor: pointer !important;
  position: relative;
  display: inline-flex;
  align-items: center;
}

.animal-filter-dropdown:hover {
  cursor: pointer !important;
}

.animal-filter-dropdown .animal-filter-select {
  cursor: pointer !important;
  position: relative;
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: none;
  background: transparent;
}

.animal-filter-dropdown:hover .animal-filter-select {
  cursor: pointer !important;
}

.filter-button.animal-filter-dropdown {
  cursor: pointer !important;
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.filter-button.animal-filter-dropdown:hover {
  cursor: pointer !important;
}

.filter-button.animal-filter-dropdown * {
  cursor: pointer !important;
}

.filter-button.animal-filter-dropdown:hover * {
  cursor: pointer !important;
}

.animal-filter-text {
  pointer-events: none;
  z-index: 0;
  position: relative;
  font-size: 0.9rem;
  font-weight: 600;
  color: #2c3e50;
}

.animal-filter-icon {
  pointer-events: none;
  z-index: 0;
  position: relative;
}
/* Desktop Table Optimization - with horizontal scroll fallback */
@media (min-width: 769px) {
  .collections-table-container {
    max-width: 100% !important;
    overflow-x: auto !important;
    padding-bottom: 12px !important;
  }

  .collections-table {
    table-layout: fixed !important;
    width: 100% !important;
    min-width: 1200px !important;
    font-size: 13.5px !important;
  }

  .collections-table th {
    padding: 4px 1px !important;
    font-size: 13px !important;
    text-align: center !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    line-height: 1.15 !important;
  }

  .collections-table td {
    padding: 3px 1px !important;
    font-size: 13.5px !important;
    text-align: center !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  /* Column 1: S.No */
  .collections-table th:first-child,
  .collections-table td:first-child {
    width: 36px !important;
  }

  /* Column 2: Date & Shift */
  .collections-table th:nth-child(2),
  .collections-table td:nth-child(2) {
    width: 100px !important;
  }

  /* Column 3: Name */
  .collections-table th:nth-child(3) {
    width: 110px !important;
  }
  .collections-table td:nth-child(3) {
    width: 110px !important;
    text-align: left !important;
  }

  /* Columns 4-9: QTY, FAT, SNF, CLR, FAT KG, SNF KG */
  .collections-table th:nth-child(n+4):nth-child(-n+9),
  .collections-table td:nth-child(n+4):nth-child(-n+9) {
    width: 45px !important;
  }

  /* Columns 10 & 11: Fat Step Up, SNF Step Down (with extra room for badges) */
  .collections-table th:nth-child(10),
  .collections-table td:nth-child(10),
  .collections-table th:nth-child(11),
  .collections-table td:nth-child(11) {
    width: 80px !important;
  }

  /* Columns 12+ (Rates, calculations, base values, animal type, amounts) */
  .collections-table th:nth-child(n+12):not(:last-child),
  .collections-table td:nth-child(n+12):not(:last-child) {
    width: 58px !important;
  }

  /* Column Last: Actions */
  .collections-table th:last-child,
  .collections-table td:last-child {
    width: 85px !important;
    min-width: 85px !important;
  }
}
/* Pro-rata Step Rate Badges */
.step-rates-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  justify-content: center;
  width: 100%;
}

.step-rate-badge {
  font-size: 12.5px !important;
  font-weight: 600 !important;
  padding: 2px 5px !important;
  border-radius: 4px !important;
  display: inline-block !important;
  text-align: center !important;
  white-space: nowrap !important;
  width: auto !important;
}

.step-rate-badge.fat-badge {
  background-color: #ecfdf5 !important;
  color: #047857 !important;
  border: 1px solid #a7f3d0 !important;
}

.step-rate-badge.snf-badge {
  background-color: #fff1f2 !important;
  color: #be123c !important;
  border: 1px solid #fecdd3 !important;
}
/* Bulk Edit Modal Fields Layout */
.bulk-edit-fields-container {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
  align-items: center !important;
  flex: 1 1 !important;
  width: 100% !important;
}

.bulk-edit-field-item {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  background: transparent !important;
  background-color: transparent !important;
  padding: 4px 8px !important;
  border: none !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
}

/* Mobile responsive layout for Bulk Edit fields - tight spacing */
@media (max-width: 768px) {
  .bulk-edit-fields-container {
    gap: 2px 2px !important;
  }

  .bulk-edit-field-item {
    padding: 1px 2px !important;
    margin: 0 !important;
  }
}

/* Bulk Edit Stats Panel Mobile Alignment */
@media (max-width: 768px) {
  .bulk-edit-stats-panel {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 12px 0 !important;
    padding: 10px 8px !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .bulk-edit-stats-divider {
    display: none !important;
  }

  .bulk-edit-stats-item {
    width: 100% !important;
    min-width: 0 !important;
    flex: none !important;
    box-sizing: border-box !important;
  }

  .bulk-edit-stats-item:nth-child(4n+1) {
    border-right: 1px solid #dee2e6 !important;
  }

  /* Pro-rata Rate Settings Modal Mobile Buttons styling */
  .rate-settings-modal .option-btn {
    padding: 8px 12px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
  }

  .rate-settings-modal .modal-footer .save-button,
  .rate-settings-modal .modal-footer .cancel-button {
    padding: 8px 12px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
  }

  .rate-settings-modal .modal-footer {
    padding: 10px 12px !important;
    gap: 8px !important;
  }

  .rate-settings-modal .modal-body {
    padding: 12px 16px !important;
  }

  .rate-settings-modal .change-rates-section {
    margin-bottom: 12px !important;
    padding: 12px !important;
  }
}

/* Ensure Name column cells are always left-aligned in standard/pro-rata preview tables */
.collections-table td.customer-name-cell,
.collections-table td:nth-child(3) {
  text-align: left !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/PreviewCollections.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,4DAA4D;EAC5D,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;EACvB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,8CAA8C;IAC9C,UAAU;EACZ;;EAEA;IACE,6CAA6C;IAC7C,YAAY;EACd;;EAEA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,qDAAqD;AACrD;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,SAAO;IACP,sBAAsB;IACtB,gBAAgB;EAClB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA,gCAAgC;AAChC;;EAEE,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;;EAEE,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;;EAEE;;IAEE,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;IACE,oBAAoB;EACtB;;EAEA,yDAAyD;EACzD;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA,0DAA0D;EAC1D;;IAEE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;EACxB;;EAEA,0CAA0C;EAC1C;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA,6BAA6B;EAC7B;IACE,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA,6BAA6B;EAC7B;IACE,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA,qCAAqC;EACrC;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;EACF;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA,gCAAgC;EAChC;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,wBAAwB;EAC1B;AACF;;AAEA,+BAA+B;AAC/B;;EAEE;;IAEE,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,gFAAgF;EAChF,wEAAwE;EACxE,+CAA+C;EAC/C,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,4CAA4C;EAC5C;IACE,aAAa;EACf;;EAEA,qDAAqD;AACvD;;AAEA;;EAEE,iDAAiD;EACjD;;;;IAIE,aAAa;EACf;AACF;;AAEA,yEAAyE;AACzE;EACE;IACE,mBAAmB;EACrB;;EAEA,yBAAyB;EACzB;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,yCAAyC;IACzC,eAAe;IACf,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,wCAAwC;IACxC,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,mEAAmE;IACnE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,uCAAuC;EACvC;IACE,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,SAAS;EACX;;EAEA,kCAAkC;EAClC;IACE,aAAa;EACf;;EAEA,mCAAmC;EACnC;;;;IAIE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,kBAAkB;EACpB;;EAEA,oBAAoB;EACpB;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,YAAY;EACd;;EAEA,wBAAwB;EACxB;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA,0CAA0C;EAC1C;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA,8BAA8B;EAC9B;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,4BAA4B;EAC5B;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,SAAO;EACT;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,oCAAoC;IACpC,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,qCAAqC;IACrC,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;IAC/B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sCAAsC;IACtC,oCAAoC;IACpC,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,+BAA+B;IAC/B,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,+BAA+B;IAC/B,UAAU;EACZ;;EAEA,mBAAmB;EACnB;IACE,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,gCAAgC;EAChC,iFAAiF;EACjF,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,iDAAiD;EACjD,wEAAwE;EACxE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0EAA0E;EAC1E,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,mFAAmF;AACrF;;AAEA,+BAA+B;AAC/B;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,iFAAiF;AACnF;;AAEA,8BAA8B;AAC9B;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,iFAAiF;AACnF;;AAEA,6BAA6B;AAC7B;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,iFAAiF;AACnF;;AAEA,+BAA+B;AAC/B;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,iFAAiF;AACnF;;AAEA,qDAAqD;AACrD;EACE,wCAAwC;EACxC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,wDAAwD;AACxD;EACE,wCAAwC;EACxC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE;IACE,kCAAkC;IAClC,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;;EAExB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;;EAElB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,6BAA6B;IAC7B,mBAAmB;IACnB,4BAA4B;IAC5B,cAAc;IACd,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,kCAAkC;IAClC,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;IAC1B,cAAc;IACd,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wEAAwE;EACxE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,+BAA+B;EAC/B,yCAAyC;EACzC,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,8CAA8C;AAC9C;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,+DAA+D;AAC/D;;EAEE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,6BAA6B;AAC/B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;IAC1B,6BAA6B;IAC7B,4CAA4C;IAC5C,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA,oDAAoD;EACpD;IACE,4BAA4B;IAC5B,8BAA8B;IAC9B,4BAA4B;IAC5B,wBAAwB;IACxB,oCAAoC;IACpC,4BAA4B;IAC5B,4BAA4B;IAC5B,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,oCAAoC;IACpC,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA,qDAAqD;EACrD;;IAEE,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;;IAEE,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;;IAEE,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;;IAEE,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;;IAEE,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA,8CAA8C;EAC9C;;IAEE,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,6BAA6B;EAC7B;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;;IAEE,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;;IAEE,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,iCAAiC;EACnC;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;;;IAIE,aAAa;EACf;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iDAAiD;EACjD,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iDAAiD;EACjD,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE;IACE,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;IAC7B,yCAAyC;EAC3C;;EAEA,qCAAqC;EACrC;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;IACpC,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,oBAAkB;IAClB,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,oBAAkB;IAClB,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,kCAAkC;IAClC,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iDAAiD;AACjD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,oCAAoC;AACpC;EAEE,qBAAqB;AACvB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;;;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8BE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,yDAAyD;AACzD;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,yCAAyC;IACzC,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;;;IAGE,oBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;IAClC,4BAA4B;IAC5B,0BAA0B;IAC1B,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,4CAA4C;EAC5C;IACE,wBAAwB;IACxB,yCAAyC;IACzC,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;IAC7B,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA,6DAA6D;EAC7D;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA,+CAA+C;EAC/C;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,4BAA4B;IAC5B,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,iCAAiC;IACjC,kCAAkC;IAClC,oBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,gCAAgC;EAChC;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,oBAAkB;IAClB,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;;;IAGE,2BAA2B;IAC3B,0BAA0B;IAC1B,mBAAmB;EACrB;AACF;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA,kDAAkD;AAClD;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,QAAQ;AACV;;AAEA,+CAA+C;AAC/C;;EAEE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,WAAW;EACb;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA,YAAY;EACZ;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA,mBAAmB;EACnB;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,QAAQ;IACR,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA,2BAA2B;EAC3B;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA,kBAAkB;EAClB;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA,2BAA2B;EAC3B;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA,YAAY;EACZ;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA,oBAAoB;EACpB;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,gEAAgE;EAChE,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,gEAAgE;EAChE,sCAAsC;EACtC,uDAAuD;AACzD;;AAEA;EACE,mCAAmC;AACrC;;AAEA,iCAAiC;AACjC;EACE,qDAAqD;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,qDAAqD;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,0CAA0C;EAC1C,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,sBAAsB;AACxB;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wEAAwE;EACxE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,eAAe;IACf,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,yCAAyC;IACzC,4BAA4B;EAC9B;;EAEA;;IAEE,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,8BAA8B;IAC9B,oBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;IACnB,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;IACpC,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;EACb;AACF;;AAEA,kEAAkE;AAClE;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0EAA0E;EAC1E,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,6DAA6D;EAC7D,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,cAAc;IACd,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,+CAA+C;AAC/C;;;;EAIE,0BAA0B;AAC5B;;AAEA,oEAAoE;AACpE;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6DAA6D;AAC7D;EACE,0BAA0B;AAC5B;;AAEA,qDAAqD;AACrD;;;;;EAKE,0BAA0B;AAC5B;;AAEA,2DAA2D;AAC3D;;EAEE,0BAA0B;AAC5B;;AAEA,0DAA0D;AAC1D;;EAEE,0BAA0B;AAC5B;;AAEA,oDAAoD;AACpD;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,4CAA4C;EAC5C,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE,0BAA0B;AAC5B;;AAEA,kEAAkE;AAClE;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2EAA2E;AAC3E;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,uDAAuD;EACvD,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;AACA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,kBAAkB;AACpB;AACA,iEAAiE;AACjE;EACE;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA,mBAAmB;EACnB;;IAEE,sBAAsB;EACxB;;EAEA,2BAA2B;EAC3B;;IAEE,uBAAuB;EACzB;;EAEA,mBAAmB;EACnB;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA,oDAAoD;EACpD;;IAEE,sBAAsB;EACxB;;EAEA,6EAA6E;EAC7E;;;;IAIE,sBAAsB;EACxB;;EAEA,yEAAyE;EACzE;;IAEE,sBAAsB;EACxB;;EAEA,yBAAyB;EACzB;;IAEE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF;AACA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;AACA,kCAAkC;AAClC;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,kEAAkE;AAClE;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,wBAAwB;IACxB,gDAAgD;IAChD,sBAAsB;IACtB,4BAA4B;IAC5B,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA,wDAAwD;EACxD;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;IAEE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,wBAAwB;EAC1B;AACF;;AAEA,yFAAyF;AACzF;;EAEE,2BAA2B;AAC7B","sourcesContent":[".collections-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: #f8f9fa;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  scroll-behavior: smooth;\n}\n\n/* Toast Message Styling */\n.toast-success {\n  background-color: #e8f5e8 !important;\n  color: #2e7d32 !important;\n  border: 1px solid #2e7d32 !important;\n}\n\n.toast-success .toast-close-button {\n  color: #2e7d32 !important;\n}\n\n.toast-error {\n  background-color: #f44336 !important;\n  color: white !important;\n}\n\n.toast-error .toast-close-button {\n  color: white !important;\n}\n\n.toast-warning {\n  background-color: #ff9800 !important;\n  color: white !important;\n}\n\n.toast-warning .toast-close-button {\n  color: white !important;\n}\n\n.toast-info {\n  background-color: #2196f3 !important;\n  color: white !important;\n}\n\n.toast-info .toast-close-button {\n  color: white !important;\n}\n\n/* Toast message structure */\n.toast-message {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  /* padding: 0 8px; */\n}\n\n.toast-message-text {\n  flex: 1;\n}\n\n.toast-close-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 4px;\n  /* align-items: end !important; */\n  /* margin-left: 12px; */\n  line-height: 1;\n  user-select: none;\n  outline: none;\n}\n\n/* Custom toast animation */\n@keyframes slideDownFromTop {\n  0% {\n    transform: translateX(-50%) translateY(-100px);\n    opacity: 0;\n  }\n\n  50% {\n    transform: translateX(-50%) translateY(-20px);\n    opacity: 0.8;\n  }\n\n  100% {\n    transform: translateX(-50%) translateY(0);\n    opacity: 1;\n  }\n}\n\n.Toastify__toast-container {\n  top: 0 !important;\n}\n\n.Toastify__toast {\n  min-height: 60px !important;\n  min-width: 400px !important;\n  margin-top: 55px !important;\n  z-index: 9999 !important;\n}\n\n.Toastify__toast--success {\n  background-color: #d4edda !important;\n  color: #155724 !important;\n}\n\n.Toastify__toast--success .Toastify__toast-body {\n  color: #155724 !important;\n}\n\n.Toastify__toast--success .Toastify__close-button {\n  color: #155724 !important;\n  font-size: 20px !important;\n  padding: 8px 12px !important;\n  opacity: 0.8 !important;\n  pointer-events: auto !important;\n  z-index: 10000 !important;\n  position: absolute !important;\n  right: 8px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n  cursor: pointer !important;\n}\n\n.Toastify__toast--success .Toastify__close-button:hover {\n  opacity: 1 !important;\n  background-color: rgba(21, 87, 36, 0.1) !important;\n  border-radius: 4px !important;\n}\n\n.Toastify__close-button {\n  pointer-events: auto !important;\n  z-index: 10001 !important;\n  position: relative !important;\n}\n\n/* Mobile responsive styles for toast notifications */\n@media (max-width: 768px) {\n  .Toastify__toast-container {\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    width: 100% !important;\n    padding: 0 10px !important;\n    box-sizing: border-box !important;\n  }\n\n  .Toastify__toast {\n    min-width: auto !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    margin-top: 10px !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    left: 0 !important;\n    transform: none !important;\n    border-radius: 8px !important;\n    min-height: 50px !important;\n  }\n\n  .Toastify__toast--success {\n    font-size: 14px !important;\n  }\n\n  .Toastify__toast--success .Toastify__toast-body {\n    font-size: 14px !important;\n    padding: 8px 12px !important;\n  }\n\n  .Toastify__toast--success .Toastify__close-button {\n    font-size: 18px !important;\n    padding: 6px 10px !important;\n  }\n\n  .toast-message {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .toast-message-text {\n    flex: 1;\n    word-break: break-word;\n    line-height: 1.4;\n  }\n}\n\n/* Extra small mobile screens */\n@media (max-width: 480px) {\n  .Toastify__toast {\n    min-height: 45px !important;\n    margin-top: 5px !important;\n  }\n\n  .Toastify__toast--success {\n    font-size: 13px !important;\n  }\n\n  .Toastify__toast--success .Toastify__toast-body {\n    font-size: 13px !important;\n    padding: 6px 10px !important;\n  }\n\n  .Toastify__toast--success .Toastify__close-button {\n    font-size: 16px !important;\n    padding: 4px 8px !important;\n  }\n}\n\n/* Ensure page starts from top */\nhtml,\nbody {\n  scroll-behavior: smooth;\n  margin: 0;\n  padding: 0;\n}\n\n/* Override any scroll positioning issues */\n.collections-container>* {\n  scroll-margin-top: 0;\n}\n\n/* Force page to start from top */\n#root {\n  scroll-behavior: smooth;\n}\n\n/* Remove any scroll offset issues within collections */\n.collections-container,\n.collections-container * {\n  scroll-margin-top: 0;\n}\n\n/* Mobile-specific fixes */\n@media (max-width: 768px) {\n\n  html,\n  body {\n    scroll-behavior: smooth;\n    margin: 0;\n    padding: 0;\n    overflow-x: hidden;\n    position: relative;\n  }\n\n  .collections-container {\n    scroll-behavior: smooth;\n    min-height: 100vh;\n    width: 100%;\n    overflow-x: hidden;\n    position: relative;\n  }\n\n  /* Force scroll to top on mobile */\n  .collections-container>* {\n    scroll-margin-top: 0;\n  }\n\n  /* Remove any fixed positioning that might cause issues */\n  .collections-header {\n    position: relative !important;\n    top: auto !important;\n    z-index: auto !important;\n  }\n\n  /* Ensure table containers don't cause horizontal scroll */\n  .collections-table-container,\n  .preview-table-container {\n    overflow-x: auto;\n    max-width: 100%;\n    position: relative;\n  }\n\n  /* Fix for mobile viewport issues */\n  .collections-content {\n    padding: 1rem;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  /* Ensure no horizontal scroll on mobile */\n  .collections-table {\n    min-width: 1200px;\n    width: 100%;\n  }\n\n  /* Mobile edit modal styles */\n  .edit-collection-modal {\n    max-width: 95%;\n    width: 95%;\n    min-width: 300px;\n    max-height: 95vh;\n    margin: 10px;\n    border-radius: 12px;\n  }\n\n  .edit-collection-container {\n    padding: 15px;\n  }\n\n  .edit-form-row {\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 12px;\n  }\n\n  .edit-form-group {\n    flex: 1;\n  }\n\n  .edit-form-input {\n    padding: 12px;\n    font-size: 16px;\n    border-radius: 8px;\n  }\n\n  .edit-form-input:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n  }\n\n  .edit-form-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 20px;\n  }\n\n  .edit-form-button {\n    padding: 12px 20px;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n\n  .edit-form-button.cancel {\n    background-color: #f3f4f6;\n    color: #374151;\n  }\n\n  .edit-form-button.preview {\n    background-color: #2563eb;\n    color: white;\n  }\n\n  .edit-form-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  .calculation-results {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 15px;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    margin-top: 15px;\n  }\n\n  .calculation-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .calculation-item label {\n    font-weight: 500;\n    color: #6b7280;\n  }\n\n  .calculation-item span {\n    font-weight: 600;\n    color: #111827;\n  }\n\n  /* Mobile edit modal styles */\n  .edit-collection-modal {\n    max-width: 95%;\n    width: 95%;\n    min-width: 300px;\n    max-height: 95vh;\n    margin: 10px;\n    border-radius: 12px;\n  }\n\n  .edit-collection-container {\n    padding: 15px;\n  }\n\n  .edit-form-row {\n    flex-direction: row;\n    gap: 12px;\n    margin-bottom: 12px;\n  }\n\n  /* Stack only on very small screens */\n  @media (max-width: 480px) {\n    .edit-form-row {\n      flex-direction: column;\n      gap: 12px;\n    }\n  }\n\n  .edit-form-group {\n    flex: 1;\n  }\n\n  .edit-form-input {\n    padding: 12px;\n    font-size: 16px;\n    border-radius: 8px;\n  }\n\n  .edit-form-input:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n  }\n\n  .edit-form-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 20px;\n  }\n\n  .edit-form-button {\n    padding: 12px 20px;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n\n  .edit-form-button.cancel {\n    background-color: #f3f4f6;\n    color: #374151;\n  }\n\n  .edit-form-button.preview {\n    background-color: #2563eb;\n    color: white;\n  }\n\n  .edit-form-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  .calculation-results {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 15px;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    margin-top: 15px;\n  }\n\n  .calculation-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .calculation-item label {\n    font-weight: 500;\n    color: #6b7280;\n  }\n\n  .calculation-item span {\n    font-weight: 600;\n    color: #111827;\n  }\n\n  /* Mobile-specific modal fixes */\n  .modal-overlay {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    z-index: 9999 !important;\n  }\n}\n\n/* Extra small mobile screens */\n@media (max-width: 480px) {\n\n  html,\n  body {\n    scroll-behavior: smooth;\n    margin: 0;\n    padding: 0;\n    overflow-x: hidden;\n    position: relative;\n  }\n\n  .collections-container {\n    scroll-behavior: smooth;\n    min-height: 100vh;\n    width: 100%;\n    overflow-x: hidden;\n    position: relative;\n  }\n\n  .collections-content {\n    padding: 0.5rem;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .collections-header {\n    position: relative !important;\n    top: auto !important;\n    padding: 0.8rem !important;\n  }\n}\n\n.collections-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 1.2rem 2.5rem;\n  /* background: linear-gradient(120deg, #eef2ff 0%, #e0f2fe 40%, #e0f7fa 100%); */\n  background: linear-gradient(135deg, #0047AB 0%, #003680 100%) !important;\n  box-shadow: 0 20px 45px rgba(79, 70, 229, 0.15);\n  position: relative;\n  border-bottom-left-radius: 24px;\n  border-bottom-right-radius: 24px;\n  border-bottom: 1px solid rgba(99, 102, 241, 0.15);\n}\n\n.header-desktop {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr);\n  align-items: center;\n}\n\n.header-left,\n.header-right {\n  /* color: white !important; */\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.header-primary {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  grid-column: span 2;\n}\n\n.header-left {\n  justify-content: flex-start;\n}\n\n.header-center h1 {\n  color: white !important;\n}\n\n.header-center {\n  /* color: white; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  text-align: center;\n}\n\n.header-right {\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.collections-header h1 {\n  margin: 0;\n  font-size: 1.6rem;\n  color: #0f172a;\n  font-weight: 700;\n}\n\n.header-search {\n  position: relative;\n  width: auto;\n}\n\n.header-search .search-input.small {\n  max-width: 220px;\n  min-width: 200px;\n}\n\n.collections-header .language-switcher .lang-btn {\n  background: #111827;\n  border: 1px solid rgba(17, 24, 39, 0.7);\n  color: #f9fafb;\n}\n\n.collections-header .language-switcher .lang-btn:hover {\n  background: #0f172a;\n  border-color: rgba(17, 24, 39, 0.85);\n}\n\n.collections-header .language-switcher .lang-icon,\n.collections-header .language-switcher .lang-text,\n.collections-header .language-switcher .lang-chevron {\n  color: #f9fafb;\n}\n\n.header-desktop {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr);\n  align-items: center;\n}\n\n.header-mobile-top,\n.header-mobile-title,\n.header-mobile-search,\n.header-mobile-lang {\n  display: none;\n}\n\n@media (max-width: 1024px) {\n\n  /* Keep desktop layout visible for tablets */\n  .header-desktop {\n    display: grid;\n  }\n\n  /* Only hide mobile layouts for tablets, not mobile */\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n\n  /* Hide mobile layouts specifically for tablets */\n  .header-mobile-top,\n  .header-mobile-title,\n  .header-mobile-search,\n  .header-mobile-lang {\n    display: none;\n  }\n}\n\n/* Tablet specific styles (768px to 1024px) - Scale down desktop layout */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .collections-filters {\n    margin-bottom: 2rem;\n  }\n\n  /* Clickable table rows */\n  .collection-row {\n    transition: all 0.2s ease;\n    cursor: default;\n  }\n\n  .collection-row.clickable-row:hover {\n    background-color: rgba(37, 99, 235, 0.05);\n    cursor: pointer;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);\n  }\n\n  .collection-row.clickable-row:active {\n    background-color: rgba(37, 99, 235, 0.1);\n    transform: translateY(0px);\n  }\n\n  .collections-header {\n    padding: 1rem 1.8rem;\n    gap: 0.6rem;\n  }\n\n  .header-desktop {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr);\n    gap: 0.8rem;\n  }\n\n  .header-primary {\n    gap: 0.8rem;\n  }\n\n  .header-left,\n  .header-right {\n    gap: 0.6rem;\n  }\n\n  .header-center h1 {\n    font-size: 1.4rem;\n  }\n\n  .header-search .search-input.small {\n    max-width: 200px;\n    min-width: 180px;\n    font-size: 0.9rem;\n    height: 38px;\n  }\n\n  .back-button-viewCollection {\n    font-size: 0.9rem;\n    padding: 0.4rem 0.6rem;\n  }\n\n  .logout-button {\n    font-size: 0.8rem;\n    padding: 0.4rem 0.6rem;\n  }\n\n  .collections-header .language-switcher .lang-btn {\n    min-width: 80px;\n    padding: 4px 8px;\n    font-size: 0.75rem;\n  }\n\n  /* Adjust content spacing for tablets */\n  .collections-content {\n    padding: 1.8rem;\n  }\n\n  /* Filter adjustments */\n  .filter-button {\n    padding: 10px 16px;\n    font-size: 0.85rem;\n    min-height: 40px;\n  }\n}\n\n@media (max-width: 768px) {\n  .collections-header {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    gap: 1rem;\n  }\n\n  /* Hide desktop layout on mobile */\n  .header-desktop {\n    display: none;\n  }\n\n  /* Show mobile elements on mobile */\n  .header-mobile-top,\n  .header-mobile-title,\n  .header-mobile-search,\n  .header-mobile-lang {\n    display: flex;\n  }\n\n  .header-mobile-search {\n    display: block;\n  }\n\n  /* Main header row with back, title, logout */\n  .header-mobile-top {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    width: 100%;\n    gap: 1rem;\n    position: relative;\n  }\n\n  /* Title in center */\n  .header-mobile-title {\n    grid-column: 2;\n    text-align: center;\n  }\n\n  .header-mobile-title h1 {\n    font-size: 1.3rem;\n    margin: 0;\n    color: white;\n  }\n\n  /* Back button on left */\n  .header-mobile-top .header-left {\n    grid-column: 1;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  /* Language switcher and logout on right */\n  .header-mobile-top .header-center {\n    grid-column: 3;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-start;\n    gap: 0.35rem;\n  }\n\n  .header-mobile-top .header-right {\n    display: none;\n    /* Hide the original right div */\n  }\n\n  .header-desktop {\n    display: none;\n  }\n\n  /* Language switcher styling */\n  .header-mobile-top .language-switcher .lang-btn {\n    width: auto;\n    min-width: 80px;\n    padding: 4px 8px;\n    font-size: 0.75rem;\n  }\n\n  /* Search bar below header */\n  .header-mobile-search {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    justify-content: center;\n  }\n\n  .header-mobile-search .header-search {\n    width: 100%;\n    max-width: 400px;\n    flex: 1;\n  }\n\n  .header-mobile-search .language-switcher {\n    flex-shrink: 0;\n  }\n\n  .header-mobile-search .search-input {\n    width: 100%;\n    padding: 0.6rem 2.5rem 0.6rem 2.5rem;\n    font-size: 0.9rem;\n    height: 40px;\n    border-radius: 20px;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    background: rgba(255, 255, 255, 0.15);\n    color: white;\n    text-align: center;\n  }\n\n  .header-mobile-search .search-input::placeholder {\n    color: rgba(255, 255, 255, 0.7);\n    text-align: center;\n  }\n\n  .header-mobile-search .search-input:focus {\n    outline: none;\n    border-color: rgba(255, 255, 255, 0.5);\n    background: rgba(255, 255, 255, 0.2);\n    text-align: left;\n  }\n\n  .header-mobile-search .search-icon {\n    left: 1rem;\n    top: 50%;\n    transform: translateY(-50%);\n    color: rgba(255, 255, 255, 0.7);\n    z-index: 1;\n  }\n\n  .header-mobile-search .clear-search-icon {\n    right: 1rem;\n    top: 50%;\n    transform: translateY(-50%);\n    color: rgba(255, 255, 255, 0.7);\n    z-index: 1;\n  }\n\n  /* Button styling */\n  .back-button-viewCollection {\n    font-size: 1rem;\n    padding: 0.5rem;\n    color: white;\n    display: flex;\n    align-items: center;\n    gap: 0.3rem;\n  }\n\n  .back-button-viewCollection span {\n    display: none;\n  }\n\n  .collections-header .logout-button {\n    font-size: 0.9rem;\n    padding: 0.5rem;\n    color: #dc3545;\n    display: flex;\n    align-items: center;\n    gap: 0.3rem;\n  }\n\n  .collections-header .logout-button span {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .collections-header {\n    padding: 0.8rem;\n    gap: 0.8rem;\n  }\n\n  .header-mobile-title h1 {\n    font-size: 1.1rem;\n  }\n\n  .header-mobile-top {\n    gap: 0.5rem;\n  }\n\n  .header-mobile-top .language-switcher .lang-btn {\n    min-width: 70px;\n    padding: 3px 6px;\n    font-size: 0.7rem;\n  }\n\n  .header-mobile-search .search-input {\n    height: 36px;\n    font-size: 0.85rem;\n    padding: 0.5rem 2rem 0.5rem 2rem;\n  }\n\n  .header-mobile-search .search-icon {\n    left: 0.8rem;\n  }\n\n  .header-mobile-search .clear-search-icon {\n    right: 0.8rem;\n  }\n\n  .back-button-viewCollection {\n    font-size: 0.9rem;\n    padding: 0.4rem;\n  }\n\n  .collections-header .logout-button {\n    font-size: 0.8rem;\n    padding: 0.4rem;\n  }\n\n  .collections-header {\n    border-bottom-left-radius: 16px;\n    border-bottom-right-radius: 16px;\n  }\n}\n\n.back-button-viewCollection {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  text-decoration: none;\n  padding: 0.4rem 0;\n}\n\n.back-button-viewCollection:hover {\n  color: white;\n  text-decoration: underline;\n}\n\n.back-button-viewCollection svg {\n  font-size: 0.9rem;\n}\n\n.logout-button {\n  background: none;\n  border: none;\n  color: #dc3545;\n  font-size: 0.8rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0;\n}\n\n.logout-button svg {\n  font-size: 0.9rem;\n}\n\n.logout-button:hover {\n  color: #c82333;\n  text-decoration: underline;\n}\n\n.collections-content {\n  flex: 1;\n  padding: 2.5rem;\n  max-width: 1500px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.collections-search {\n  margin-bottom: 1.5rem;\n}\n\n/* New filter styles */\n.collections-filters {\n  margin-bottom: 0.75rem !important;\n}\n\n.filter-card {\n  background: white;\n  border-radius: 12px !important;\n  padding: 0.75rem 1rem !important;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  position: relative;\n  overflow: visible;\n}\n\n.filter-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at top right, rgba(79, 70, 229, 0.08), transparent 45%);\n  pointer-events: none;\n}\n\n.filter-card-header {\n  display: flex;\n  align-items: center !important;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 0.5rem !important;\n}\n\n.filter-card-header h3 {\n  margin: 0;\n  font-size: 1.05rem !important;\n  font-weight: 700;\n  color: #111827;\n}\n\n.filter-card-header p {\n  display: none !important;\n}\n\n.filter-card-badge {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 999px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.3);\n}\n\n@media (max-width: 768px) {\n  .filter-card-badge {\n    font-size: 0.75rem;\n    padding: 0.4rem 0.8rem;\n  }\n}\n\n.report-button-wrapper {\n  display: flex;\n  align-items: stretch;\n}\n\n.filter-options {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem !important;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.filter-button {\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 8px !important;\n  padding: 6px 12px !important;\n  display: flex;\n  align-items: center;\n  gap: 6px !important;\n  cursor: pointer;\n  font-size: 13px !important;\n  font-weight: 600;\n  color: #2c3e50;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);\n  position: relative;\n  overflow: hidden;\n  min-height: 32px !important;\n}\n\n.filter-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  transition: left 0.5s;\n}\n\n.filter-button:hover::before {\n  left: 100%;\n}\n\n.filter-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12), 0 4px 10px rgba(0, 0, 0, 0.08);\n  border-color: rgba(0, 0, 0, 0.12);\n}\n\n.filter-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.filter-button svg {\n  font-size: 1.1rem;\n  opacity: 0.8;\n  transition: all 0.3s ease;\n}\n\n.filter-button:hover svg {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n/* Premium Customer Filter Button */\n.customer-filter-button {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  border-color: #64b5f6;\n  color: #1565c0;\n}\n\n.customer-filter-button:hover {\n  background: linear-gradient(135deg, #bbdefb 0%, #90caf9 100%);\n  border-color: #42a5f5;\n  box-shadow: 0 8px 25px rgba(33, 150, 243, 0.2), 0 4px 10px rgba(33, 150, 243, 0.15);\n}\n\n/* Premium Date Filter Button */\n.filter-button.date-filter-button {\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);\n  border-color: #81c784;\n  color: #2e7d32;\n}\n\n.filter-button.date-filter-button:hover {\n  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);\n  border-color: #66bb6a;\n  box-shadow: 0 8px 25px rgba(76, 175, 80, 0.2), 0 4px 10px rgba(76, 175, 80, 0.15);\n}\n\n/* Premium Sort Order Button */\n.filter-button.sort-order-button {\n  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);\n  border-color: #ffb74d;\n  color: #e65100;\n}\n\n.filter-button.sort-order-button:hover {\n  background: linear-gradient(135deg, #ffe0b2 0%, #ffcc80 100%);\n  border-color: #ffa726;\n  box-shadow: 0 8px 25px rgba(255, 152, 0, 0.2), 0 4px 10px rgba(255, 152, 0, 0.15);\n}\n\n/* Premium Milk Rate Button */\n.filter-button.milk-rate-button {\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);\n  border-color: #00916c;\n  color: #008f6a;\n}\n\n.filter-button.milk-rate-button:hover {\n  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);\n  border-color: #4caf50;\n  box-shadow: 0 8px 25px rgba(76, 175, 80, 0.25), 0 4px 10px rgba(76, 175, 80, 0.2);\n}\n\n/* Premium Bulk Update Button */\n.filter-button.bulk-update-button {\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);\n  border-color: #66bb6a;\n  color: #2e7d32;\n}\n\n.filter-button.bulk-update-button:hover {\n  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);\n  border-color: #4caf50;\n  box-shadow: 0 8px 25px rgba(76, 175, 80, 0.25), 0 4px 10px rgba(76, 175, 80, 0.2);\n}\n\n/* Add styles for rate chart button - no background */\n.filter-button.rate-chart-button {\n  background-color: transparent !important;\n  border: 1px solid #dee2e6 !important;\n  color: #495057 !important;\n}\n\n.filter-button.rate-chart-button:hover {\n  background-color: #f8f9fa !important;\n  border-color: #adb5bd !important;\n}\n\n/* Add styles for rate settings button - no background */\n.filter-button.rate-settings-button {\n  background-color: transparent !important;\n  border: 1px solid #dee2e6 !important;\n  color: #495057 !important;\n}\n\n.filter-button.rate-settings-button:hover {\n  background-color: #f8f9fa !important;\n  border-color: #adb5bd !important;\n}\n\n.pro-rata-button {\n  background-color: #f3e5f5;\n  border-color: #ba68c8;\n  color: #7b1fa2;\n}\n\n.pro-rata-button:hover {\n  background-color: #e1bee7;\n  border-color: #ab47bc;\n}\n\n.milk-rate-button {\n  background-color: #fff3e0;\n  border-color: #ffb74d;\n  color: #e65100;\n}\n\n.milk-rate-button:hover {\n  background-color: #ffe0b2;\n  border-color: #ffa726;\n}\n\n.active-filter {\n  display: flex;\n  align-items: center;\n  background-color: #e9f2ff;\n  border: 1px solid #b8daff;\n  border-radius: 4px;\n  padding: 0.5rem 1rem;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  color: #0062cc;\n}\n\n.active-filter.date-filter {\n  background-color: #e9fff2;\n  border-color: #b8ffd9;\n  color: #00a67c;\n}\n\n.active-filters-summary {\n  margin-top: 1rem;\n  padding: 0.75rem 1rem;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border-left: 4px solid #007bff;\n  font-size: 0.9rem;\n  color: #495057;\n}\n\n.active-filters-summary p {\n  margin: 0;\n}\n\n.filter-action-buttons {\n  display: inline-flex;\n  gap: 10px;\n  margin-left: 15px;\n}\n\n.clear-filter-button {\n  background: rgba(108, 117, 125, 0.1);\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.clear-filter-button:hover {\n  background-color: rgba(108, 117, 125, 0.2);\n  color: #495057;\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(2px);\n}\n\n.modal-content {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  width: 95%;\n  max-width: 600px;\n  min-width: 320px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  backdrop-filter: none;\n}\n\n.customer-modal {\n  max-width: 600px;\n  background-color: white;\n  border: 1px solid #ddd;\n  padding: 0;\n}\n\n.date-filter-modal {\n  max-width: 500px;\n  background-color: white;\n  border: 1px solid #ddd;\n  padding: 0;\n}\n\n/* Mobile responsive styles for date filter modal */\n@media (max-width: 768px) {\n  .modal-overlay {\n    align-items: flex-start !important;\n    justify-content: center;\n    padding: 12px !important;\n    padding-top: 25px !important;\n    overflow-y: auto;\n    min-height: 100vh;\n    width: 100%;\n  }\n\n  .date-filter-modal {\n    max-width: 100% !important;\n    width: 85% !important;\n    max-width: 350px !important;\n    /* width: 320px; */\n    margin: 0 auto !important;\n    position: relative;\n    top: 0 !important;\n    border-radius: 10px;\n    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);\n    background: white;\n    max-height: calc(100vh - 50px);\n    overflow: visible;\n    display: flex;\n    flex-direction: column;\n\n  }\n\n  .modal-content {\n    max-width: 100% !important;\n    width: 100% !important;\n    margin: 0 !important;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    max-height: none;\n\n  }\n\n  .modal-header {\n    padding: 10px 16px;\n    border-bottom: 1px solid #e9ecef;\n    flex-shrink: 0;\n  }\n\n  .modal-header h2 {\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n  }\n\n  .modal-close-button {\n    font-size: 1rem;\n    color: #666;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 3px;\n  }\n\n  .date-input-group {\n    margin-bottom: 14px;\n    padding: 0 18px;\n  }\n\n  .date-input-group label {\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: #555;\n    margin-bottom: 6px;\n    display: block;\n  }\n\n  .date-input {\n    padding: 10px 12px;\n    font-size: 14px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .date-input:focus {\n    border-color: #00a67c;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(0, 166, 124, 0.1);\n  }\n\n  .date-filter-actions {\n    padding: 14px 18px;\n    gap: 8px;\n    border-top: 1px solid #f0f0f0;\n    background: #fafafa;\n    border-radius: 0 0 10px 10px;\n    flex-shrink: 0;\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .date-filter-button {\n    padding: 10px 16px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 70px;\n  }\n\n  .date-filter-button.primary {\n    background: #00a67c;\n    color: white;\n  }\n\n  .date-filter-button.primary:hover {\n    background: #008f6a;\n  }\n\n  .date-filter-button.secondary {\n    background: #f8f9fa;\n    color: #666;\n    border: 1px solid #ddd;\n  }\n\n  .date-filter-button.secondary:hover {\n    background: #e9ecef;\n  }\n}\n\n/* Extra small mobile screens */\n@media (max-width: 480px) {\n  .modal-overlay {\n    align-items: flex-start !important;\n    justify-content: center;\n    padding: 8px !important;\n    padding-top: 20px !important;\n    overflow-y: auto;\n    min-height: 100vh;\n  }\n\n  .date-filter-modal {\n    max-width: 100% !important;\n    width: 90% !important;\n    max-width: 320px !important;\n    /* width: 320px; */\n    margin: 0 auto !important;\n    position: relative;\n    top: 0 !important;\n    border-radius: 8px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n    background: white;\n    max-height: calc(100vh - 40px);\n    overflow: visible;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .modal-content {\n    max-width: 100% !important;\n    width: 100% !important;\n    margin: 0 !important;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    max-height: none;\n  }\n\n  .modal-header {\n    padding: 12px 16px;\n    border-bottom: 1px solid #e9ecef;\n    flex-shrink: 0;\n  }\n\n  .modal-header h2 {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n  }\n\n  .modal-close-button {\n    font-size: 0.9rem;\n    color: #666;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 2px;\n  }\n\n  .date-input-group {\n    margin-bottom: 12px;\n    padding: 0 16px;\n  }\n\n  .date-input-group label {\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: #555;\n    margin-bottom: 5px;\n    display: block;\n  }\n\n  .date-input {\n    padding: 9px 11px;\n    font-size: 14px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .date-input:focus {\n    border-color: #00a67c;\n    outline: none;\n    box-shadow: 0 0 0 1px rgba(0, 166, 124, 0.1);\n  }\n\n  .date-filter-actions {\n    padding: 12px 16px;\n    gap: 6px;\n    border-top: 1px solid #f0f0f0;\n    background: #fafafa;\n    border-radius: 0 0 8px 8px;\n    flex-shrink: 0;\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .date-filter-button {\n    padding: 9px 14px;\n    font-size: 0.75rem;\n    font-weight: 500;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 60px;\n  }\n\n  .date-filter-button.primary {\n    background: #00a67c;\n    color: white;\n  }\n\n  .date-filter-button.primary:hover {\n    background: #008f6a;\n  }\n\n  .date-filter-button.secondary {\n    background: #f8f9fa;\n    color: #666;\n    border: 1px solid #ddd;\n  }\n\n  .date-filter-button.secondary:hover {\n    background: #e9ecef;\n  }\n}\n\n.modal-header {\n  padding: 12px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e9ecef;\n  background-color: #fff;\n}\n\n.modal-header-bulk {\n  padding: 8px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e9ecef;\n  background-color: #fff;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  color: #333;\n}\n\n.modal-close-button {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.modal-close-button:hover {\n  color: #343a40;\n}\n\n.customer-search-container {\n  padding: 20px;\n  border-bottom: 1px solid #e9ecef;\n  background-color: #f8f9fa;\n}\n\n.date-filter-container {\n  padding: 20px;\n  background-color: white;\n}\n\n.date-input-group {\n  margin-bottom: 20px;\n}\n\n.date-input-group label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #495057;\n}\n\n.date-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.date-input:focus {\n  border-color: #00a67c;\n  box-shadow: 0 0 0 0.2rem rgba(0, 166, 124, 0.25);\n}\n\n.date-filter-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.date-filter-button {\n  padding: 10px 16px;\n  border: none;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.date-filter-button.secondary {\n  background-color: #f8f9fa;\n  color: #6c757d;\n  border: 1px solid #ced4da;\n}\n\n.date-filter-button.secondary:hover {\n  background-color: #e9ecef;\n  color: #495057;\n}\n\n.date-filter-button.primary {\n  background-color: #00a67c;\n  color: white;\n}\n\n.date-filter-button.primary:hover {\n  background-color: #00916c;\n}\n\n.customers-list {\n  padding: 0;\n  overflow-y: auto;\n  max-height: 400px;\n  background-color: white;\n}\n\n.customer-item {\n  padding: 15px 20px;\n  border-bottom: 1px solid #e9ecef;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.customer-item:hover {\n  background-color: #f8f9fa;\n}\n\n.customer-item:last-child {\n  border-bottom: none;\n  margin-bottom: 10px;\n}\n\n.customer-name {\n  font-weight: 500;\n  color: #212529;\n}\n\n.customer-code {\n  color: #6c757d;\n  font-size: 0.85rem;\n  margin-top: 0.25rem;\n}\n\n.no-customers {\n  padding: 30px 20px;\n}\n\n.search-wrapper {\n  position: relative;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #adb5bd;\n}\n\n.clear-search-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #adb5bd;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.clear-search-icon:hover {\n  color: #6c757d;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.75rem 1rem 0.75rem 2.5rem;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.2s;\n  padding-right: 2.5rem;\n}\n\n.search-input:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.collections-list {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  max-width: 100%;\n}\n\n/* Premium Collection Table Styles */\n.collections-table-container {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1);\n  max-width: 100%;\n  margin-bottom: 1rem;\n  padding: 0.5rem;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  overflow-x: auto !important;\n}\n\n.collections-table {\n  min-width: 1400px !important;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border-radius: 12px;\n  overflow: hidden;\n  font-size: 15px !important;\n  table-layout: auto;\n}\n\n.collections-table thead tr {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-bottom: 2px solid #dee2e6;\n}\n\n.collections-table th {\n  padding: 10px 8px !important;\n  font-weight: 700;\n  text-align: center;\n  position: relative;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  color: #2c3e50;\n  border-right: 1px solid #e9ecef;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  font-size: 16px !important;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n}\n\n.collections-table th:first-child {\n  border-left: none;\n  border-top-left-radius: 12px;\n}\n\n.collections-table th:last-child {\n  border-right: none;\n  border-top-right-radius: 12px;\n}\n\n.collections-table tbody tr {\n  border-bottom: 1px solid #f1f3f4;\n  transition: all 0.2s ease;\n}\n\n.collections-table tbody tr:hover {\n  background: linear-gradient(135deg, #f8f9ff 0%, #eef7ff 100%);\n  transform: scale(1.01);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.collections-table tbody tr:nth-child(even) {\n  background-color: #fafbfc;\n}\n\n.collections-table tbody tr:nth-child(even):hover {\n  background: linear-gradient(135deg, #f0f7ff 0%, #e8f4ff 100%);\n}\n\n.collections-table td {\n  padding: 8px 10px !important;\n  text-align: left;\n  border-bottom: 1px solid #f1f3f4;\n  font-size: 16.5px !important;\n  font-weight: 500;\n  color: #2c3e50;\n  border-right: 1px solid #f8f9fa;\n}\n\n.collections-table td:first-child {\n  border-left: none;\n}\n\n.collections-table td:last-child {\n  border-right: none;\n}\n\n.collections-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.collections-table tbody tr:last-child td:first-child {\n  border-bottom-left-radius: 12px;\n}\n\n.collections-table tbody tr:last-child td:last-child {\n  border-bottom-right-radius: 12px;\n}\n\n/* Column widths - optimized for desktop fit */\n.collections-table th:nth-child(1),\n.collections-table td:nth-child(1) {\n  min-width: 40px;\n  text-align: center;\n}\n\n.collections-table th:nth-child(2),\n.collections-table td:nth-child(2) {\n  min-width: 100px;\n  white-space: nowrap;\n}\n\n.collections-table th:nth-child(3),\n.collections-table td:nth-child(3) {\n  min-width: 60px;\n  text-align: right;\n}\n\n.collections-table th:nth-child(4),\n.collections-table td:nth-child(4) {\n  min-width: 50px !important;\n  max-width: 50px !important;\n  width: 50px !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.collections-table th:nth-child(5),\n.collections-table td:nth-child(5) {\n  min-width: 100px;\n  text-align: left;\n}\n\n.collections-table th:nth-child(n+6):nth-child(-n+14),\n.collections-table td:nth-child(n+6):nth-child(-n+14) {\n  min-width: 70px;\n  white-space: nowrap;\n  text-align: right;\n}\n\n/* SNF KG column (9th) needs extra width for full Hindi label */\n.collections-table th:nth-child(9),\n.collections-table td:nth-child(9) {\n  min-width: 90px;\n  white-space: nowrap;\n  text-align: right;\n}\n\n.collections-table th:nth-child(15),\n.collections-table td:nth-child(15) {\n  min-width: 50px;\n  text-align: center;\n}\n\n/* Keep the collection-header and collection-item rules for backward compatibility */\n.collection-header {\n  display: flex;\n  background-color: #f1f3f5;\n  padding: 1rem;\n  font-weight: bold;\n  border-bottom: 1px solid #dee2e6;\n  position: relative;\n  min-width: max-content;\n}\n\n.collection-item {\n  display: flex;\n  padding: 1rem;\n  border-bottom: 1px solid #e9ecef;\n  transition: background-color 0.2s;\n  min-width: max-content;\n}\n\n.collection-item:hover {\n  background-color: #f8f9fa;\n}\n\n.collection-item:last-child {\n  border-bottom: none;\n}\n\n.collection-column {\n  min-width: 100px;\n  padding: 0 0.5rem;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.collection-column:nth-child(1) {\n  min-width: 90px;\n}\n\n.collection-column:nth-child(2) {\n  min-width: 150px;\n}\n\n.collection-column:nth-child(3) {\n  min-width: 130px;\n}\n\n.collection-column:nth-child(4),\n.collection-column:nth-child(5),\n.collection-column:nth-child(6),\n.collection-column:nth-child(7),\n.collection-column:nth-child(8),\n.collection-column:nth-child(9) {\n  min-width: 80px;\n}\n\n.collection-column:nth-child(10),\n.collection-column:nth-child(11),\n.collection-column:nth-child(12),\n.collection-column:nth-child(13) {\n  min-width: 90px;\n}\n\n.error-message {\n  text-align: center;\n  padding: 2rem;\n  color: #dc3545;\n  background-color: #f8d7da;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.error-message button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  margin-top: 1rem;\n  cursor: pointer;\n}\n\n.error-message button:hover {\n  background-color: #c82333;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid #007bff;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.no-collections {\n  text-align: center;\n  padding: 3rem;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.load-more {\n  text-align: center;\n  margin: 2rem 0;\n}\n\n.load-more-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 0.75rem 2rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.2s;\n  margin-bottom: 1rem;\n}\n\n.load-more-button:hover {\n  background-color: #0069d9;\n}\n\n.load-custom-options {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.load-custom-button {\n  background-color: #f8f9fa;\n  color: #007bff;\n  border: 1px solid #007bff;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n}\n\n.load-custom-button:hover {\n  background-color: #007bff;\n  color: white;\n}\n\n.collections-footer {\n  text-align: center;\n  padding: 20px 0;\n  background-color: #f8f9fa;\n  color: #666;\n  border-top: 1px solid #e0e0e0;\n}\n\n/* Bulk Update Rate Type Selection Modal */\n.rate-type-selector-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.rate-type-selector-btn:hover {\n  background: #5a67d8;\n}\n\n.rate-type-selector-btn:active {\n  background: #764ba2;\n}\n\n.rate-type-selection-modal {\n  max-width: 350px;\n  width: 85%;\n  max-height: 280px;\n}\n\n.rate-type-selection-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #f8f9fa;\n}\n\n.rate-type-selection-modal .modal-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.rate-type-selection-modal .modal-body-rate-type {\n  padding: 20px;\n}\n\n.rate-type-options {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n}\n\n.rate-type-option {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  width: 100%;\n}\n\n.rate-type-option:hover {\n  border-color: #667eea;\n  background-color: #f8f9ff;\n}\n\n.rate-type-option.active {\n  border-color: #667eea;\n  background-color: #667eea;\n  color: white;\n}\n\n.rate-type-option span {\n  margin-left: 8px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .rate-type-option span {\n    font-size: 11px;\n  }\n\n  .heading-bulk-update {\n    font-size: 14px !important;\n  }\n}\n\n.rate-type-option svg {\n  font-size: 18px;\n  color: #667eea;\n  width: 20px;\n  height: 20px;\n}\n\n.rate-type-option.active svg {\n  color: white;\n}\n\n/* Modal header content layout */\n.modal-header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 16px;\n}\n\n.heading-bulk-update {\n  font-size: 20px;\n}\n\n.modal-header-content h2 {\n  margin: 0;\n  flex: 1;\n}\n\n.edit-bulk-values {\n  display: flex;\n  flex-direction: row !important;\n  gap: 5px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .rate-type-selection-modal {\n    width: 95%;\n    max-height: 350px;\n  }\n\n  .rate-type-option {\n    padding: 16px;\n  }\n\n  .rate-type-option-content {\n    gap: 12px;\n  }\n\n  .rate-type-option-content h4 {\n    font-size: 15px;\n  }\n\n  .rate-type-option-content p {\n    font-size: 13px;\n  }\n\n  .rate-type-selector-btn {\n    padding: 4px 8px;\n    font-size: 12px;\n  }\n\n  .filter-bulk {\n    display: flex;\n    flex-direction: row;\n  }\n}\n\n/* Responsive styles */\n@media (max-width: 1500px) {\n  .collections-table-container {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 1200px) {\n  .collections-content {\n    max-width: 100%;\n    padding: 1.5rem;\n  }\n\n  .collections-table-container {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .collections-header {\n    padding: 0.75rem 1rem;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .collections-header h1 {\n    font-size: 1.1rem;\n    text-align: left;\n    width: 100%;\n  }\n\n  .header-left,\n  .header-right {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .header-right {\n    gap: 0.5rem;\n    width: fit-content;\n    /* border: solid 2px red; */\n  }\n\n  .collections-content {\n    padding: 0.5rem;\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  /* Enable horizontal scrolling on mobile */\n  .collections-table-container {\n    max-width: 100vw !important;\n    border-radius: 6px !important;\n    padding: 0.5rem !important;\n    overflow-x: scroll !important;\n    -webkit-overflow-scrolling: touch !important;\n    width: 100vw !important;\n    position: relative !important;\n  }\n\n  /* Set minimum width to accommodate all 15 columns */\n  .collections-table {\n    font-size: 0.8rem !important;\n    table-layout: fixed !important;\n    min-width: 1300px !important;\n    width: 1300px !important;\n    border-collapse: separate !important;\n    border-spacing: 0 !important;\n    overflow: visible !important;\n    display: table !important;\n  }\n\n  .collections-table th,\n  .collections-table td {\n    padding: 6px 4px !important;\n    font-size: 0.7rem !important;\n    white-space: nowrap !important;\n    border: 1px solid #f1f3f4 !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n\n  /* Mobile column widths - proper sizing with scroll */\n  .collections-table th:nth-child(1),\n  .collections-table td:nth-child(1) {\n    min-width: 35px !important;\n    max-width: 35px !important;\n    width: 35px !important;\n  }\n\n  .collections-table th:nth-child(2),\n  .collections-table td:nth-child(2) {\n    min-width: 100px !important;\n    max-width: 100px !important;\n    width: 100px !important;\n  }\n\n  .collections-table th:nth-child(3),\n  .collections-table td:nth-child(3) {\n    min-width: 60px !important;\n    max-width: 60px !important;\n    width: 60px !important;\n  }\n\n  .collections-table th:nth-child(4),\n  .collections-table td:nth-child(4) {\n    min-width: 45px !important;\n    max-width: 45px !important;\n    width: 45px !important;\n  }\n\n  .collections-table th:nth-child(5),\n  .collections-table td:nth-child(5) {\n    min-width: 120px !important;\n    max-width: 120px !important;\n    width: 120px !important;\n  }\n\n  .collections-table th:nth-child(n+6):nth-child(-n+14),\n  .collections-table td:nth-child(n+6):nth-child(-n+14) {\n    min-width: 70px !important;\n    max-width: 70px !important;\n    width: 70px !important;\n    text-align: right !important;\n  }\n\n  .collections-table th:nth-child(15),\n  .collections-table td:nth-child(15) {\n    min-width: 70px !important;\n    max-width: 70px !important;\n    width: 70px !important;\n    text-align: center !important;\n  }\n\n  /* 16th column for PreviewProRataCollections */\n  .collections-table th:nth-child(16),\n  .collections-table td:nth-child(16) {\n    min-width: 70px !important;\n    max-width: 70px !important;\n    width: 70px !important;\n    text-align: center !important;\n  }\n\n  .collection-header,\n  .collection-item {\n    font-size: 0.8rem;\n  }\n\n  .collections-header h1 {\n    font-size: 1.2rem;\n  }\n\n  /* Action buttons on mobile */\n  .actions-cell {\n    min-width: 70px !important;\n    max-width: 70px !important;\n    padding: 2px !important;\n    gap: 2px !important;\n  }\n\n  .edit-button,\n  .delete-button {\n    padding: 4px 6px !important;\n    font-size: 0.6rem !important;\n    min-width: 30px !important;\n  }\n\n  .edit-button svg,\n  .delete-button svg {\n    font-size: 10px !important;\n  }\n}\n\n/* Additional mobile breakpoint for smaller screens */\n@media (max-width: 480px) {\n  .collections-table-container {\n    padding: 0.25rem !important;\n  }\n\n  .collections-table {\n    min-width: 1300px !important;\n    width: 1300px !important;\n    font-size: 0.65rem !important;\n  }\n\n  .collections-table th,\n  .collections-table td {\n    padding: 4px 2px !important;\n    font-size: 0.6rem !important;\n  }\n\n  .collections-table th:nth-child(2),\n  .collections-table td:nth-child(2) {\n    min-width: 90px !important;\n    max-width: 90px !important;\n    width: 90px !important;\n  }\n\n  .collections-table th:nth-child(5),\n  .collections-table td:nth-child(5) {\n    min-width: 100px !important;\n    max-width: 100px !important;\n    width: 100px !important;\n  }\n\n  .collections-table th:nth-child(n+6):nth-child(-n+14),\n  .collections-table td:nth-child(n+6):nth-child(-n+14) {\n    min-width: 60px !important;\n    max-width: 60px !important;\n    width: 60px !important;\n  }\n\n  .filter-bulk {\n    display: flex;\n    flex-direction: column !important;\n  }\n}\n\n/* Print styles for exporting to PDF/printing */\n@media print {\n  .collections-table-container {\n    overflow: visible;\n    width: 100%;\n    box-shadow: none;\n  }\n\n  .collections-table {\n    width: 100%;\n    border: 1px solid #000;\n  }\n\n  .collections-table th,\n  .collections-table td {\n    border: 1px solid #000;\n  }\n\n  .collections-header,\n  .collections-footer,\n  .collections-search,\n  .load-more {\n    display: none;\n  }\n}\n\n/* Table action column styling */\n.actions-cell {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  min-width: 120px;\n  padding: 8px;\n}\n\n/* Premium Action Buttons */\n.edit-button {\n  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 600;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.filter-bulk {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.edit-button:hover {\n  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);\n}\n\n.delete-button {\n  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 600;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.3);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.delete-button:hover {\n  background: linear-gradient(135deg, #d32f2f 0%, #c62828 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.4);\n}\n\n/* Confirmation Modal Styles */\n.confirmation-modal {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);\n  width: 95%;\n  max-width: 600px;\n  min-width: 320px;\n  overflow: hidden;\n}\n\n.confirmation-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.confirmation-modal .modal-header h3 {\n  margin: 0;\n  color: #e74c3c;\n  font-size: 1.25rem;\n}\n\n.confirmation-modal .modal-body {\n  padding: 20px;\n}\n\n.confirmation-modal .modal-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding: 12px 16px;\n  background-color: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n  gap: 10px;\n}\n\n.confirmation-modal .modal-footer .cancel-button {\n  padding: 8px 20px !important;\n  font-size: 13px !important;\n  min-width: 90px;\n  border-radius: 6px !important;\n  flex: 0 0 auto;\n}\n\n.confirmation-modal .modal-footer .delete-button {\n  padding: 8px 20px !important;\n  font-size: 13px !important;\n  min-width: 90px;\n  border-radius: 6px !important;\n  flex: 0 0 auto;\n  justify-content: center;\n}\n\n.collection-delete-info {\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  padding: 15px;\n  margin: 15px 0;\n  border-left: 4px solid #e74c3c;\n}\n\n.collection-delete-info p {\n  margin: 5px 0;\n  font-size: 15px;\n}\n\n.warning-text {\n  color: #e74c3c;\n  font-weight: 500;\n  margin-top: 10px;\n}\n\n.cancel-button {\n  background-color: #f8f9fa;\n  color: #3c4043;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.cancel-button:hover {\n  background-color: #f1f3f4;\n  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);\n}\n\n.cancel-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* ===== Delete Confirmation Modal - Mobile Compact ===== */\n@media (max-width: 768px) {\n  .confirmation-modal {\n    width: 92% !important;\n    max-width: 92% !important;\n    min-width: 0 !important;\n    border-radius: 10px !important;\n  }\n\n  .confirmation-modal .modal-header {\n    padding: 10px 14px !important;\n  }\n\n  .confirmation-modal .modal-header h3 {\n    font-size: 1rem !important;\n    margin: 0 !important;\n  }\n\n  .confirmation-modal .modal-close-button {\n    font-size: 0.95rem !important;\n    width: 22px !important;\n    height: 22px !important;\n  }\n\n  .confirmation-modal .modal-body {\n    padding: 12px 14px !important;\n  }\n\n  .confirmation-modal .modal-body p {\n    font-size: 13px !important;\n    margin-bottom: 8px !important;\n  }\n\n  .collection-delete-info {\n    padding: 10px 12px !important;\n    margin: 10px 0 !important;\n    border-radius: 6px !important;\n  }\n\n  .collection-delete-info p {\n    font-size: 12px !important;\n    margin: 4px 0 !important;\n  }\n\n  .warning-text {\n    font-size: 12px !important;\n    margin-top: 8px !important;\n    padding: 6px 10px !important;\n    background-color: #fff3f3 !important;\n    border-radius: 5px !important;\n    border-left: 3px solid #e74c3c !important;\n  }\n\n  /* Buttons side-by-side and compact */\n  .confirmation-modal .modal-footer {\n    display: flex !important;\n    flex-direction: row !important;\n    justify-content: flex-end !important;\n    gap: 8px !important;\n    padding: 10px 14px !important;\n  }\n\n  .confirmation-modal .modal-footer .cancel-button {\n    flex: 1 !important;\n    padding: 8px 10px !important;\n    font-size: 12px !important;\n    border-radius: 6px !important;\n    text-align: center !important;\n    max-width: 48% !important;\n  }\n\n  .confirmation-modal .modal-footer .delete-button {\n    flex: 1 !important;\n    padding: 8px 10px !important;\n    font-size: 12px !important;\n    border-radius: 6px !important;\n    justify-content: center !important;\n    max-width: 48% !important;\n  }\n}\n\n/* Edit Collection Modal */\n.edit-collection-modal {\n  max-width: 900px !important;\n  width: 95%;\n  min-width: 320px;\n  max-height: 90vh;\n  overflow-y: auto;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.edit-collection-container {\n  padding: 15px;\n  background-color: #fff;\n}\n\n.edit-form-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.edit-form-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.edit-text {\n  font-weight: 500 !important;\n  color: #000 !important;\n}\n\n.edit-form-input {\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* Hide spinner buttons in Chrome, Safari, Edge */\n.edit-form-input.no-spinners::-webkit-outer-spin-button,\n.edit-form-input.no-spinners::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Hide spinner buttons in Firefox */\n.edit-form-input.no-spinners {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n\n.edit-form-input.error {\n  border-color: #e74c3c;\n}\n\n.edit-input-error {\n  color: #e74c3c;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n.edit-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.edit-form-button {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.edit-form-button.cancel {\n  background-color: #f1f1f1;\n  color: #333;\n}\n\n.edit-form-button.save {\n  background-color: #27ae60;\n  color: white;\n}\n\n.edit-form-button.cancel:hover {\n  background-color: #e5e5e5;\n}\n\n.edit-form-button.save:hover {\n  background-color: #219653;\n}\n\n.edit-form-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.edit-form-error {\n  background-color: #ffebee;\n  color: #c62828;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n\n.calculation-results {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.calculation-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 5px;\n}\n\n.calculation-item label {\n  font-weight: 500;\n  min-width: 70px;\n}\n\n.calculation-item span {\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.button-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Edit Form Button - Preview Button */\n.edit-form-button.preview {\n  background-color: #00a67c;\n  color: white;\n}\n\n.edit-form-button.preview:hover {\n  background-color: #00916c;\n}\n\n/* Preview Modal Styles */\n.preview-modal {\n  width: 90%;\n  max-width: 1200px;\n  height: fit-content !important;\n  max-height: 95vh;\n  overflow-y: auto;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  min-height: auto !important;\n}\n\n.preview-modal .modal-body {\n  padding: 20px 30px;\n  overflow: visible;\n}\n\n.preview-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px 30px;\n  border-top: 1px solid #e8eaed;\n  background-color: #f8f9fa;\n  gap: 15px;\n}\n\n.preview-header {\n  background-color: #f0f7ff;\n  padding: 15px 20px;\n  border-radius: 6px;\n  border-left: 4px solid #1976d2;\n  margin-bottom: 20px;\n}\n\n.preview-info {\n  font-size: 18px;\n  color: #424242;\n  margin: 0;\n  line-height: 1.6;\n}\n\n.preview-table-container {\n  overflow-x: auto;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border-radius: 6px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.preview-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n.preview-table th,\n.preview-table td {\n  padding: 16px 24px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n  white-space: nowrap;\n}\n\n/* Add alternating row colors for better readability */\n.preview-table tbody tr:nth-child(even) {\n  background-color: #f5f9ff;\n}\n\n.preview-table tbody tr:hover {\n  background-color: #eaf0fb;\n}\n\n/* Improve column spacing with min-width */\n.preview-table th {\n  background-color: #f0f5fa;\n  font-weight: 600;\n  color: #444;\n  position: relative;\n  border-bottom: 2px solid #ddd;\n  min-width: 100px;\n  font-size: 17px;\n}\n\n/* Increase font size for table data */\n.preview-table td {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n/* Ensure certain columns have proper width */\n.preview-table th:nth-child(1),\n/* DateTime */\n.preview-table td:nth-child(1) {\n  min-width: 120px;\n  max-width: 140px;\n  width: fit-content;\n}\n\n.preview-table th:nth-child(2),\n/* Date */\n.preview-table td:nth-child(2) {\n  min-width: 120px;\n}\n\n.preview-table th:nth-child(4),\n/* Milk Type */\n.preview-table td:nth-child(4) {\n  min-width: 90px;\n}\n\n.preview-table th:nth-child(5),\n/* Collection Time */\n.preview-table td:nth-child(5) {\n  min-width: 120px;\n}\n\n/* Numeric columns with right alignment */\n.preview-table th:nth-child(3),\n/* Weight */\n.preview-table td:nth-child(3),\n.preview-table th:nth-child(6),\n/* Fat % */\n.preview-table td:nth-child(6),\n.preview-table th:nth-child(7),\n/* CLR */\n.preview-table td:nth-child(7),\n.preview-table th:nth-child(8),\n/* SNF % */\n.preview-table td:nth-child(8),\n.preview-table th:nth-child(9),\n/* Fat KG */\n.preview-table td:nth-child(9),\n.preview-table th:nth-child(10),\n/* SNF KG */\n.preview-table td:nth-child(10),\n.preview-table th:nth-child(11),\n/* Fat Rate */\n.preview-table td:nth-child(11),\n.preview-table th:nth-child(12),\n/* SNF Rate */\n.preview-table td:nth-child(12),\n.preview-table th:nth-child(13),\n/* Base SNF % */\n.preview-table td:nth-child(13),\n.preview-table th:nth-child(14),\n/* Milk Rate */\n.preview-table td:nth-child(14) {\n  text-align: right;\n  min-width: 100px;\n  padding-right: 30px;\n}\n\n/* Special styling for monetary values */\n.preview-table td:nth-child(15) {\n  font-weight: 600;\n  color: #2e7d32;\n  font-size: 16px;\n}\n\n/* Add more visual separation between groups of columns */\n.preview-table th:nth-child(5),\n/* After Collection Time */\n.preview-table td:nth-child(5) {\n  border-right: 2px solid #ddd;\n}\n\n.preview-table th:nth-child(8),\n/* After SNF % */\n.preview-table td:nth-child(8) {\n  border-right: 2px solid #ddd;\n}\n\n.preview-table th:nth-child(12),\n/* After SNF Rate */\n.preview-table td:nth-child(12) {\n  border-right: 2px solid #ddd;\n}\n\n.preview-table th:nth-child(13),\n/* After Base SNF % */\n.preview-table td:nth-child(13) {\n  border-right: 2px solid #ddd;\n}\n\n.confirm-button,\n.cancel-button {\n  margin-left: 12px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: all 0.2s;\n  font-size: 16px;\n  gap: 8px;\n}\n\n.cancel-button {\n  background: #f8f9fa;\n  color: #3c4043;\n  border: 1px solid #dadce0;\n}\n\n.cancel-button:hover {\n  background: #f1f3f4;\n  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);\n}\n\n.confirm-button {\n  background: #1a73e8;\n  color: white;\n}\n\n.confirm-button:hover {\n  background: #1765cc;\n  box-shadow: 0 1px 3px rgba(26, 115, 232, 0.4);\n}\n\n.confirm-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background: #4d90fe;\n  box-shadow: none;\n}\n\n/* Responsive styles for preview modal */\n@media (max-width: 1200px) {\n  .preview-modal {\n    max-width: 95%;\n    margin: 15px;\n  }\n\n  .preview-table {\n    min-width: 800px;\n  }\n}\n\n@media (max-width: 768px) {\n  .preview-modal {\n    width: 95% !important;\n    height: fit-content !important;\n    max-height: 85vh !important;\n    margin: 5px !important;\n    min-height: auto !important;\n  }\n\n  .preview-modal .modal-header {\n    padding: 12px 16px !important;\n  }\n\n  .preview-modal .modal-header h2 {\n    font-size: 1.2rem !important;\n    margin: 0 !important;\n  }\n\n  .preview-modal .close-modal-button {\n    font-size: 1.1rem !important;\n    width: 24px !important;\n    height: 24px !important;\n  }\n\n  .preview-modal .modal-body {\n    padding: 10px 12px !important;\n    overflow: visible !important;\n  }\n\n  .preview-header {\n    padding: 8px 12px !important;\n    margin-bottom: 12px !important;\n    border-left-width: 3px !important;\n  }\n\n  .preview-info {\n    font-size: 12px !important;\n    line-height: 1.4 !important;\n  }\n\n  .preview-table-container {\n    margin-top: 8px !important;\n  }\n\n  .preview-table th,\n  .preview-table td {\n    padding: 6px 8px !important;\n    font-size: 11px !important;\n  }\n\n  .modal-footer-preview {\n    flex-direction: row !important;\n    justify-content: space-between !important;\n    gap: 8px !important;\n    padding: 10px 12px !important;\n  }\n\n  .cancel-button-preview,\n  .confirm-button-preview,\n  .rate-settings-btn-preview {\n    flex: 1 !important;\n    width: auto !important;\n    justify-content: center !important;\n    padding: 8px 10px !important;\n    font-size: 11px !important;\n    white-space: nowrap !important;\n    gap: 4px !important;\n  }\n}\n\n/* ===== Edit Collection Modal - Mobile Compact ===== */\n@media (max-width: 768px) {\n  .edit-collection-modal {\n    max-width: 98% !important;\n    width: 98% !important;\n    max-height: 92vh !important;\n    margin: 4% auto !important;\n    border-radius: 10px !important;\n    overflow-y: auto !important;\n  }\n\n  .edit-collection-modal .modal-header {\n    padding: 10px 14px !important;\n  }\n\n  .edit-collection-modal .modal-header h2 {\n    font-size: 1rem !important;\n    margin: 0 !important;\n  }\n\n  .edit-collection-modal .modal-close-button {\n    font-size: 1rem !important;\n    width: 22px !important;\n    height: 22px !important;\n  }\n\n  .edit-collection-container {\n    padding: 10px 12px !important;\n  }\n\n  /* 2-column grid on mobile for compactness */\n  .edit-form-row {\n    display: grid !important;\n    grid-template-columns: 1fr 1fr !important;\n    gap: 8px !important;\n    margin-bottom: 8px !important;\n  }\n\n  .edit-form-group {\n    flex: unset !important;\n  }\n\n  .edit-text {\n    font-size: 11px !important;\n    margin-bottom: 3px !important;\n    display: block !important;\n  }\n\n  .edit-form-input {\n    padding: 7px 8px !important;\n    font-size: 12px !important;\n    border-radius: 5px !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Supplier row — full width since it has the select button */\n  .edit-form-row:first-of-type {\n    grid-template-columns: 1fr !important;\n  }\n\n  .customer-select-container {\n    gap: 6px !important;\n  }\n\n  .customer-select-button {\n    padding: 7px 10px !important;\n    font-size: 11px !important;\n    white-space: nowrap !important;\n    flex-shrink: 0 !important;\n  }\n\n  /* Calculation results - compact 3-column row */\n  .calculation-results {\n    flex-direction: row !important;\n    flex-wrap: wrap !important;\n    padding: 8px 10px !important;\n    gap: 6px !important;\n    margin-top: 6px !important;\n  }\n\n  .calculation-item {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    flex: 1 !important;\n    min-width: 70px !important;\n    gap: 2px !important;\n  }\n\n  .calculation-item label {\n    font-size: 10px !important;\n    color: #6b7280 !important;\n    min-width: unset !important;\n  }\n\n  .calculation-item span {\n    font-size: 12px !important;\n    font-weight: 600 !important;\n  }\n\n  /* Action buttons side by side */\n  .edit-form-actions {\n    display: flex !important;\n    flex-direction: row !important;\n    gap: 8px !important;\n    margin-top: 10px !important;\n  }\n\n  .edit-form-button {\n    flex: 1 !important;\n    padding: 9px 10px !important;\n    font-size: 12px !important;\n    border-radius: 6px !important;\n    justify-content: center !important;\n  }\n\n  .edit-input-error {\n    font-size: 10px !important;\n    margin-top: 2px !important;\n  }\n}\n\n@media (max-width: 479px) {\n  .preview-modal .modal-header h2 {\n    font-size: 1rem !important;\n  }\n\n  .preview-info {\n    font-size: 11px !important;\n  }\n\n  .preview-table th,\n  .preview-table td {\n    padding: 4px 6px !important;\n    font-size: 10px !important;\n  }\n\n  .cancel-button-preview,\n  .confirm-button-preview,\n  .rate-settings-btn-preview {\n    padding: 6px 8px !important;\n    font-size: 10px !important;\n    gap: 2px !important;\n  }\n}\n\n/* Customer selection in edit form */\n.customer-select-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.customer-select-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.2s ease;\n}\n\n.customer-select-button:hover {\n  background-color: #2980b9;\n}\n\n.customer-select-container .edit-form-input {\n  flex: 1;\n}\n\n/* Make customer modal appear above other modals */\n.modal-overlay .customer-modal {\n  z-index: 1010;\n}\n\n/* Modal header styling */\n.preview-modal .modal-header {\n  padding: 22px 28px;\n  border-bottom: 1px solid #e8eaed;\n  background-color: #f8f9fa;\n}\n\n.preview-modal .modal-header h2 {\n  margin: 0;\n  font-size: 1.7rem;\n  color: #1976d2;\n}\n\n/* Preview modal footer styling */\n.modal-footer-preview {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px 30px;\n  border-top: 1px solid #e8eaed;\n  background-color: #f8f9fa;\n  gap: 8px;\n}\n\n/* Preview modal buttons - smaller on desktop */\n.cancel-button-preview,\n.confirm-button-preview {\n  padding: 8px 16px;\n  font-size: 14px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: all 0.2s;\n  gap: 8px;\n}\n\n.cancel-button-preview {\n  background: #f8f9fa;\n  color: #3c4043;\n  border: 1px solid #dadce0;\n}\n\n.cancel-button-preview:hover {\n  background: #f1f3f4;\n  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);\n  transform: translateY(-1px);\n}\n\n.confirm-button-preview {\n  background: #2563eb;\n  color: white;\n}\n\n.confirm-button-preview:hover {\n  background: #1d4ed8;\n  transform: translateY(-1px);\n}\n\n.confirm-button-preview:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.collections-table td.customer-name-cell,\n.collections-table td:nth-child(3) {\n  text-align: left !important;\n}\n\n/* Collection Summary Statistics */\n.collection-summary-stats {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  padding: 0;\n  margin: 24px 0;\n  overflow: hidden;\n  border: 1px solid #e8eaed;\n}\n\n.summary-header {\n  background-color: #f0f7ff;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e8eaed;\n  border-left: 4px solid #1976d2;\n}\n\n.summary-header h3 {\n  margin: 0;\n  color: #1976d2;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.stats-container {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 20px;\n  gap: 20px;\n}\n\n.stat-item {\n  flex: 1;\n  min-width: 180px;\n  background-color: #f9fafc;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n  border: 1px solid #eef1f6;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.stat-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);\n}\n\n.stat-label {\n  font-size: 14px;\n  color: #5f6368;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 22px;\n  font-weight: 600;\n  color: #202124;\n}\n\n.stat-item:nth-child(1) .stat-value {\n  color: #4338ca;\n}\n\n.stat-item:nth-child(2) .stat-value {\n  color: #166534;\n}\n\n.stat-item:nth-child(3) .stat-value {\n  color: #9a3412;\n}\n\n.stat-item:nth-child(4) .stat-value {\n  color: #0369a1;\n}\n\n.stat-item:nth-child(5) .stat-value {\n  color: #6b21a8;\n}\n\n.stat-item:nth-child(6) .stat-value {\n  color: #047857;\n}\n\n.stat-item:nth-child(7) .stat-value {\n  color: #b45309;\n}\n\n.stat-footer {\n  background-color: #f8f9fa;\n  padding: 16px 20px;\n  border-top: 1px solid #e8eaed;\n  text-align: right;\n  font-size: 15px;\n  color: #424242;\n}\n\n.final-amount {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1e8e3e;\n}\n\n@media (max-width: 768px) {\n\n  /* Header */\n  .collections-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .collections-header h1 {\n    font-size: 1.1rem;\n  }\n\n  .back-button-viewCollection,\n  .logout-button {\n    font-size: 0.75rem;\n    gap: 0.3rem;\n  }\n\n  .back-button-viewCollection svg,\n  .logout-button svg {\n    font-size: 0.8rem;\n  }\n\n  /* Content */\n  .collections-content {\n    padding: 1rem;\n  }\n\n  .collections-filters {\n    margin-bottom: 2rem;\n    margin-top: 3rem;\n  }\n\n  /* Search */\n  .search-wrapper {\n    margin-bottom: 0.75rem;\n  }\n\n  .search-input {\n    padding: 0.6rem 2.5rem 0.6rem 2.5rem;\n    font-size: 0.85rem;\n  }\n\n  .search-icon,\n  .clear-search-icon {\n    font-size: 0.9rem;\n  }\n\n  /* Filter buttons */\n  .filter-options {\n    gap: 0.5rem;\n    padding: 0.25rem 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .filter-button {\n    padding: 0.65rem 0.75rem;\n    font-size: 0.8rem;\n    gap: 5px;\n    justify-content: center;\n    width: 100%;\n  }\n\n  .filter-button svg {\n    font-size: 0.9rem;\n  }\n\n  /* Active filters summary */\n  .active-filters-summary {\n    padding: 0.75rem;\n    margin-top: 0.75rem;\n    font-size: 0.8rem;\n  }\n\n  .active-filters-summary p {\n    margin-bottom: 0.5rem;\n  }\n\n  .clear-filter-button {\n    padding: 0.35rem 0.6rem;\n    font-size: 0.75rem;\n  }\n\n  /* Collections table */\n  .collections-table-container {\n    margin: 1rem 0;\n  }\n\n  .collections-table {\n    font-size: 0.7rem;\n  }\n\n  .collections-table th,\n  .collections-table td {\n    padding: 0.5rem 0.4rem;\n  }\n\n  /* Summary stats */\n  .collection-summary-stats {\n    margin: 1rem 0;\n  }\n\n  .summary-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .summary-header h3 {\n    font-size: 0.95rem;\n  }\n\n  .stats-container {\n    flex-direction: column;\n    padding: 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .stat-item {\n    width: 100%;\n    min-width: unset;\n    padding: 0.75rem;\n  }\n\n  .stat-label {\n    font-size: 0.75rem;\n    margin-bottom: 0.4rem;\n  }\n\n  .stat-value {\n    font-size: 1rem;\n  }\n\n  .stat-footer {\n    padding: 0.75rem 1rem;\n    font-size: 0.8rem;\n  }\n\n  .final-amount {\n    font-size: 1rem;\n  }\n\n  /* No collections message */\n  .no-collections {\n    padding: 1.5rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  /* Loading */\n  .loading-container {\n    padding: 1.5rem 1rem;\n  }\n\n  .loading-container p {\n    font-size: 0.85rem;\n  }\n\n  /* Error message */\n  .error-message {\n    padding: 1rem;\n    font-size: 0.85rem;\n  }\n\n  .error-message button {\n    padding: 0.5rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  /* Success message */\n  .success-message {\n    padding: 0.75rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  .success-message p {\n    font-size: 0.85rem;\n  }\n}\n\n.success-message {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n  padding: 12px 20px;\n  margin: 10px 0;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.success-message p {\n  margin: 0;\n  font-size: 16px;\n}\n\n/* Bulk Update Modal Styling */\n.bulk-update-button {\n  background: linear-gradient(135deg, #28a745, #20c997) !important;\n  border: none !important;\n  color: white !important;\n  font-weight: 600 !important;\n  transition: all 0.3s ease !important;\n  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3) !important;\n}\n\n.bulk-update-button:hover {\n  background: linear-gradient(135deg, #218838, #1ea085) !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.4) !important;\n}\n\n.bulk-update-button:active {\n  transform: translateY(0) !important;\n}\n\n/* Enhanced Filter Info Section */\n.filter-info {\n  background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 25px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.filter-info p {\n  margin: 8px 0;\n  font-size: 14px;\n  color: #495057;\n  display: flex;\n  align-items: center;\n}\n\n.filter-info p:first-child {\n  font-size: 16px;\n  color: #007bff;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.filter-info p strong {\n  color: #212529;\n  margin-right: 8px;\n}\n\n/* Enhanced Form Groups */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #495057;\n  font-size: 14px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  background-color: #fff;\n  box-sizing: border-box;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n  transform: translateY(-1px);\n}\n\n.form-group input:hover {\n  border-color: #adb5bd;\n}\n\n/* Enhanced Modal Actions */\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin: 25px 0 0 0;\n  padding-top: 20px;\n  border-top: 1px solid #dee2e6;\n}\n\n.cancel-button,\n.submit-button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 120px;\n  justify-content: center;\n}\n\n.cancel-button {\n  background-color: #6c757d;\n  color: white;\n  border: 2px solid #6c757d;\n}\n\n.cancel-button:hover {\n  background-color: #5a6268;\n  border-color: #545b62;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(108, 117, 125, 0.3);\n}\n\n.submit-button {\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  color: white;\n  border: 2px solid #007bff;\n}\n\n.submit-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #0056b3, #004085);\n  border-color: #0056b3;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);\n}\n\n.submit-button:disabled {\n  background-color: #6c757d;\n  border-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Enhanced Error Message */\n.error-message {\n  background: linear-gradient(135deg, #f8d7da, #f5c6cb);\n  border: 1px solid #dc3545;\n  border-radius: 8px;\n  padding: 15px 20px;\n  margin-bottom: 20px;\n  color: #721c24;\n  font-weight: 500;\n  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.1);\n}\n\n/* Enhanced Modal Header */\n.modal-header h2 {\n  color: #212529;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .modal-actions {\n    flex-direction: column;\n  }\n\n  .cancel-button,\n  .submit-button {\n    width: 100%;\n  }\n\n  .filter-info {\n    padding: 15px;\n  }\n\n  .form-group input {\n    padding: 10px 14px;\n  }\n}\n\n/* Rate Settings Modal Styles */\n.rate-settings-modal {\n  background: white;\n  border-radius: 8px;\n  width: 95%;\n  max-width: 600px;\n  min-width: 320px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.rate-settings-modal .modal-body {\n  padding: 24px 28px;\n}\n\n.rate-settings-modal .change-rates-section {\n  margin-bottom: 24px;\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  background-color: #f8f9fa;\n}\n\n.rate-settings-modal .change-rates-section h4 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.rate-settings-modal .change-rates-section .section-description {\n  margin: 0 0 16px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.rate-settings-modal .option-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.rate-settings-modal .option-btn {\n  flex: 1;\n  min-width: 80px;\n  padding: 10px 12px;\n  border: 2px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.rate-settings-modal .option-btn:hover {\n  border-color: #1976d2;\n  background: #f5f9ff;\n}\n\n.rate-settings-modal .option-btn.active {\n  border-color: #1976d2 !important;\n  background: #1976d2 !important;\n  color: white !important;\n}\n\n/* Rate Settings Button */\n.rate-settings-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.rate-settings-btn:hover {\n  background-color: #1565c0;\n}\n\n.rate-settings-btn svg {\n  font-size: 14px;\n}\n\n/* Preview modal footer with left-aligned rate settings */\n.modal-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-top: 1px solid #e8eaed;\n  background-color: #f8f9fa;\n}\n\n.modal-footer .rate-settings-btn {\n  order: -1;\n  /* Move rate settings button to the left */\n  margin-right: auto;\n  /* Push it to the far left */\n}\n\n.modal-footer .cancel-button {\n  margin-left: auto;\n  /* Keep cancel on the right */\n}\n\n.modal-footer .confirm-button {\n  margin-left: 12px;\n  /* Space between cancel and confirm */\n}\n\n/* Bulk Update Modal Styles */\n.bulk-update-modal {\n  max-width: 700px;\n  width: 95%;\n  min-width: 320px;\n}\n\n.bulk-update-modal .modal-content {\n  padding: 0;\n}\n\n.bulk-update-modal .modal-body {\n  padding: 24px;\n  display: flex;\n  gap: 32px;\n}\n\n.bulk-update-modal .left-column {\n  flex: 1;\n}\n\n.bulk-update-modal .right-column {\n  flex: 1;\n}\n\n.bulk-update-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 5px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  margin-bottom: 5px;\n  align-items: flex-start;\n}\n\n.bulk-update-summary p {\n  margin: 5px 0;\n  color: #495057;\n  font-size: 15px !important;\n  /* line-height: 1.5; */\n}\n\n\n\n.bulk-update-summary p strong {\n  color: #212529;\n}\n\n.method-summary {\n  display: flex;\n  gap: 5px;\n}\n\n.bulk-update-field {\n  display: flex;\n}\n\n.bulk-update-field .form-input:disabled {\n  background-color: #f8f9fa !important;\n  color: #6c757d !important;\n  border-color: #dee2e6 !important;\n  cursor: not-allowed !important;\n  opacity: 0.7 !important;\n}\n\n.bulk-update-field .form-input:disabled:hover {\n  background-color: #f8f9fa !important;\n  border-color: #dee2e6 !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.bulk-update-field label {\n  font-weight: 500;\n  color: #495057;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.bulk-update-field label:has(+ .form-input:disabled) {\n  color: #6c757d !important;\n}\n\n.bulk-update-field .field-hint {\n  font-size: 12px;\n  color: #6c757d;\n  margin-top: 4px;\n  display: block;\n}\n\n.bulk-update-form-view {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.bulk-update-form-view .form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.bulk-update-form-view .form-group label {\n  font-weight: 500;\n  color: #495057;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.bulk-update-form-view .form-input {\n  padding: 12px 16px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  background-color: #fff;\n}\n\n.bulk-update-form-view .form-input:focus {\n  outline: none;\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.bulk-update-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid #dee2e6;\n  background-color: #f8f9fa;\n}\n\n.bulk-update-modal .cancel-button {\n  padding: 10px 20px;\n  border: 1px solid #6c757d;\n  background-color: #fff;\n  color: #6c757d;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.15s ease-in-out;\n}\n\n.bulk-update-modal .cancel-button:hover {\n  background-color: #e9ecef;\n  border-color: #5a6268;\n}\n\n.bulk-update-modal .update-button {\n  padding: 10px 20px;\n  border: none;\n  background-color: #007bff;\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.15s ease-in-out;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.bulk-update-modal .update-button:hover {\n  background-color: #0056b3;\n}\n\n.bulk-update-modal .update-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n.button-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #ffffff;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Modal Overlay for Pro Rata */\n.modal-overlay-prorata {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n  backdrop-filter: blur(2px);\n  width: 100%;\n  height: 100%;\n}\n\n/* Pro Rata Confirmation Modal Styles */\n.prorata-confirmation-modal {\n  width: 90%;\n  max-width: 90vw;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.prorata-confirmation-modal .modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e9ecef;\n  background-color: #f8f9fa;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.prorata-confirmation-modal .modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #1976d2;\n  font-weight: 600;\n}\n\n.prorata-confirmation-modal .modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.prorata-confirmation-modal .confirmation-summary {\n  background-color: #e7f3ff;\n  border-left: 4px solid #1976d2;\n  padding: 16px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.prorata-confirmation-modal .confirmation-summary p {\n  margin: 8px 0;\n  color: #333;\n  font-size: 14px;\n}\n\n.prorata-confirmation-modal .confirmation-summary p:first-child {\n  margin-top: 0;\n  font-weight: 600;\n  color: #1976d2;\n}\n\n.prorata-confirmation-modal .confirmation-table-wrapper {\n  overflow-x: auto;\n  overflow-y: visible;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  margin: 20px 0;\n  flex: 1;\n  min-height: 0;\n}\n\n.prorata-confirmation-modal .confirmation-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.prorata-confirmation-modal .confirmation-table thead {\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.prorata-confirmation-modal .confirmation-table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  white-space: nowrap;\n  border-right: 1px solid #dee2e6;\n}\n\n.prorata-confirmation-modal .confirmation-table th:last-child {\n  border-right: none;\n}\n\n.prorata-confirmation-modal .confirmation-table td {\n  padding: 12px;\n  border-right: 1px solid #dee2e6;\n  color: #555;\n}\n\n.prorata-confirmation-modal .confirmation-table td:last-child {\n  border-right: none;\n}\n\n.prorata-confirmation-modal .confirmation-table tbody tr {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.prorata-confirmation-modal .confirmation-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.prorata-confirmation-modal .confirmation-table td.highlight-new {\n  background-color: #fff9e6;\n  font-weight: 600;\n  color: #d97706;\n}\n\n.prorata-confirmation-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #e9ecef;\n  background-color: #f8f9fa;\n  flex-shrink: 0;\n}\n\n.prorata-confirmation-modal .cancel-button {\n  padding: 10px 24px;\n  background-color: #ffffff;\n  color: #333;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.prorata-confirmation-modal .cancel-button:hover:not(:disabled) {\n  background-color: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n.prorata-confirmation-modal .confirm-button {\n  padding: 10px 24px;\n  background-color: #1976d2;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s;\n}\n\n.prorata-confirmation-modal .confirm-button:hover:not(:disabled) {\n  background-color: #1565c0;\n  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);\n}\n\n.prorata-confirmation-modal .confirm-button:disabled {\n  background-color: #90caf9;\n  cursor: not-allowed;\n}\n\n.prorata-confirmation-modal .cancel-button:disabled {\n  color: #adb5bd;\n  border-color: #dee2e6;\n  cursor: not-allowed;\n}\n\n/* Bulk Update Confirmation Modal Styles */\n.confirmation-modal {\n  width: 90%;\n  max-width: 1400px;\n  height: 85vh;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.confirmation-modal .modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e9ecef;\n  background-color: #f8f9fa;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.confirmation-modal .modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #1976d2;\n  font-weight: 600;\n}\n\n.confirmation-modal .modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.confirmation-summary {\n  background-color: #e7f3ff;\n  border-left: 4px solid #1976d2;\n  padding: 16px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.confirmation-summary p {\n  margin: 8px 0;\n  color: #333;\n  font-size: 14px;\n}\n\n.confirmation-summary p:first-child {\n  margin-top: 0;\n  font-weight: 600;\n  color: #1976d2;\n}\n\n.confirmation-table-wrapper {\n  overflow-x: auto;\n  overflow-y: auto;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  margin: 20px 0;\n  flex: 1;\n  min-height: 0;\n}\n\n.confirmation-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.confirmation-table thead {\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.confirmation-table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  white-space: nowrap;\n  border-right: 1px solid #dee2e6;\n}\n\n.confirmation-table th:last-child {\n  border-right: none;\n}\n\n.confirmation-table td {\n  padding: 12px;\n  border-right: 1px solid #dee2e6;\n  color: #555;\n}\n\n.confirmation-table td:last-child {\n  border-right: none;\n}\n\n.confirmation-table tbody tr {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.confirmation-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.confirmation-table td.highlight-new {\n  background-color: #fff9e6;\n  font-weight: 600;\n  color: #d97706;\n}\n\n.confirmation-modal .modal-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 12px 16px;\n  border-top: 1px solid #e9ecef;\n  background-color: #f8f9fa;\n  flex-shrink: 0;\n}\n\n.confirmation-modal .cancel-button {\n  padding: 10px 24px;\n  background-color: #ffffff;\n  color: #333;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.confirmation-modal .cancel-button:hover:not(:disabled) {\n  background-color: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n.confirmation-modal .confirm-button {\n  padding: 10px 24px;\n  background-color: #1976d2;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s;\n}\n\n.confirmation-modal .confirm-button:hover:not(:disabled) {\n  background-color: #1565c0;\n  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);\n}\n\n.confirmation-modal .confirm-button:disabled {\n  background-color: #90caf9;\n  cursor: not-allowed;\n}\n\n.confirmation-modal .cancel-button:disabled {\n  color: #adb5bd;\n  border-color: #dee2e6;\n  cursor: not-allowed;\n}\n\n/* Responsive styles for confirmation modal */\n@media (max-width: 1024px) {\n  .confirmation-modal {\n    max-width: 90%;\n    max-height: 90vh;\n  }\n\n  .confirmation-table {\n    font-size: 12px;\n  }\n\n  .confirmation-table th,\n  .confirmation-table td {\n    padding: 10px;\n  }\n}\n\n@media (max-width: 768px) {\n  .confirmation-modal {\n    width: 95%;\n    max-height: 95vh;\n    margin: 10px;\n  }\n\n  .confirmation-modal .modal-header {\n    padding: 16px;\n  }\n\n  .confirmation-modal .modal-header h2 {\n    font-size: 1.25rem;\n  }\n\n  .confirmation-modal .modal-body {\n    padding: 16px;\n  }\n\n  .confirmation-table {\n    font-size: 11px;\n  }\n\n  .confirmation-table th,\n  .confirmation-table td {\n    padding: 8px;\n  }\n\n  .confirmation-modal .modal-footer {\n    padding: 12px 16px;\n    flex-direction: column;\n  }\n\n  .confirmation-modal .cancel-button,\n  .confirmation-modal .confirm-button {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* Rate Chart Modal Styles */\n.rate-chart-modal {\n  max-width: 600px;\n  width: 90%;\n}\n\n.rate-chart-container {\n  padding: 20px;\n}\n\n.rate-chart-info h3,\n.rate-chart-formula h3 {\n  color: #2c3e50;\n  margin-bottom: 15px;\n  font-size: 18px;\n  border-bottom: 2px solid #3498db;\n  padding-bottom: 8px;\n}\n\n.rate-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n  margin-bottom: 25px;\n}\n\n.rate-info-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 15px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #3498db;\n}\n\n.rate-info-item label {\n  font-weight: 600;\n  color: #555;\n  margin: 0;\n}\n\n.rate-info-item span {\n  font-weight: 500;\n  color: #2c3e50;\n  font-size: 16px;\n}\n\n.formula-box {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n  border-left: 4px solid #e74c3c;\n}\n\n.formula-box p {\n  margin: 0 0 10px 0;\n  color: #555;\n}\n\n.formula-box code {\n  display: block;\n  background-color: #2c3e50;\n  color: #ecf0f1;\n  padding: 12px;\n  border-radius: 6px;\n  font-family: 'Courier New', monospace;\n  font-size: 14px;\n  line-height: 1.4;\n  margin-bottom: 15px;\n  word-break: break-all;\n}\n\n.rate-chart-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  width: 100%;\n  justify-content: center;\n}\n\n.rate-chart-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.rate-chart-button:active {\n  transform: translateY(0);\n}\n\n.rate-chart-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n@media (max-width: 768px) {\n  .rate-chart-modal {\n    width: 95%;\n    max-width: none;\n    margin: 10px;\n  }\n\n  .rate-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .rate-info-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n\n  .formula-box code {\n    font-size: 12px;\n    padding: 10px;\n  }\n}\n\n/* Bulk Update Modal Footer Buttons */\n.modal-footer-bulk-update {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  padding: 20px;\n  border-top: 1px solid #e9ecef;\n  background-color: #f8f9fa;\n}\n\n.cancel-button-bulk-update {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border: 1px solid #dee2e6;\n  color: #6c757d;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 100px;\n  justify-content: center;\n}\n\n.cancel-button-bulk-update:hover:not(:disabled) {\n  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);\n  border-color: #adb5bd;\n  color: #495057;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.cancel-button-bulk-update:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.confirm-button-bulk-update {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  border: 1px solid #28a745;\n  color: white;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 140px;\n  justify-content: center;\n}\n\n.confirm-button-bulk-update:hover:not(:disabled) {\n  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);\n  border-color: #1e7e34;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.3);\n}\n\n.confirm-button-bulk-update:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Mobile responsive for bulk update buttons */\n@media (max-width: 768px) {\n  .modal-footer-bulk-update {\n    display: flex !important;\n    flex-direction: row !important;\n    gap: 8px !important;\n    padding: 8px !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    flex-wrap: nowrap !important;\n  }\n\n  .cancel-button-bulk-update,\n  .confirm-button-bulk-update {\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: clip !important;\n    flex: 1 !important;\n    width: 50% !important;\n    min-width: 0 !important;\n    padding: 8px 4px !important;\n    font-size: 10.5px !important;\n    gap: 4px !important;\n    box-sizing: border-box !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-footer-bulk-update {\n    padding: 6px !important;\n    gap: 4px !important;\n  }\n\n  .cancel-button-bulk-update,\n  .confirm-button-bulk-update {\n    padding: 8px 2px !important;\n    font-size: 9.5px !important;\n    gap: 2px !important;\n  }\n\n  .cancel-button-bulk-update svg,\n  .confirm-button-bulk-update svg {\n    font-size: 10px !important;\n  }\n}\n\n/* Pro Rata Shift Right Container - Desktop Only */\n@media (min-width: 1025px) {\n  .pro-shift-right {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: flex-end !important;\n    gap: 12px;\n    margin-left: auto;\n  }\n}\n\n/* Mobile and Tablet - Keep default layout */\n@media (max-width: 1024px) {\n  .pro-shift-right {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n  }\n}\n\n/* Milk Rate Preview Modal - Input and Select Placeholder Styles */\n.preview-modal input::placeholder,\n.preview-modal select::placeholder,\n.collections-container input::placeholder,\n.collections-container select::placeholder,\n.dashboard-container input::placeholder,\n.dashboard-container select::placeholder {\n  color: #9e9e9e !important;\n  opacity: 1 !important;\n}\n\n.preview-modal input::-webkit-input-placeholder,\n.preview-modal select::-webkit-input-placeholder,\n.collections-container input::-webkit-input-placeholder,\n.collections-container select::-webkit-input-placeholder,\n.dashboard-container input::-webkit-input-placeholder,\n.dashboard-container select::-webkit-input-placeholder {\n  color: #9e9e9e !important;\n  opacity: 1 !important;\n}\n\n.preview-modal input::-moz-placeholder,\n.preview-modal select::-moz-placeholder,\n.collections-container input::-moz-placeholder,\n.collections-container select::-moz-placeholder,\n.dashboard-container input::-moz-placeholder,\n.dashboard-container select::-moz-placeholder {\n  color: #9e9e9e !important;\n  opacity: 1 !important;\n}\n\n.preview-modal input:-ms-input-placeholder,\n.preview-modal select:-ms-input-placeholder,\n.collections-container input:-ms-input-placeholder,\n.collections-container select:-ms-input-placeholder,\n.dashboard-container input:-ms-input-placeholder,\n.dashboard-container select:-ms-input-placeholder {\n  color: #9e9e9e !important;\n  opacity: 1 !important;\n}\n\n/* Final Submit Confirmation Modal Styles */\n.bulk-final-confirmation-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2), 0 8px 20px rgba(0, 0, 0, 0.15);\n  max-width: 500px;\n  width: 90%;\n  max-height: 85vh;\n  overflow-y: auto;\n  position: relative;\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px) scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modal-header-confirmation {\n  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);\n  padding: 1rem;\n  text-align: center;\n  position: relative;\n}\n\n.modal-header-confirmation h2 {\n  margin: 0;\n  color: white;\n  font-size: 1.2rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.modal-body-confirmation-card {\n  padding: 0;\n  background: white;\n}\n\n.bulk-final-confirmation-content {\n  padding: 1.2rem;\n  text-align: center;\n}\n\n.bulk-final-confirmation-icon {\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: center;\n}\n\n.bulk-final-confirmation-icon svg {\n  font-size: 2.5rem;\n  color: #dc3545;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.bulk-final-confirmation-title {\n  color: #dc3545;\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 0 0 0.8rem 0;\n  line-height: 1.3;\n}\n\n.bulk-final-confirmation-text {\n  color: #495057;\n  font-size: 0.95rem;\n  margin: 0 0 1rem 0;\n  line-height: 1.4;\n}\n\n.bulk-final-confirmation-changes {\n  list-style: none;\n  padding: 1rem;\n  margin: 0 0 1rem 0;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #0056b3;\n  text-align: left;\n}\n\n.bulk-final-confirmation-changes li {\n  margin-bottom: 0.5rem;\n  color: #495057;\n  font-size: 0.9rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n}\n\n.bulk-final-confirmation-changes li:last-child {\n  margin-bottom: 0;\n}\n\n.bulk-final-confirmation-changes strong {\n  color: #212529;\n  font-weight: 600;\n}\n\n.bulk-final-confirmation-warning {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  border: 1px solid #90caf9;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  text-align: left;\n}\n\n.bulk-final-confirmation-warning strong {\n  color: #1565c0;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.3rem;\n}\n\n.bulk-final-confirmation-warning p {\n  color: #1565c0;\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.4;\n}\n\n.bulk-final-confirmation-question {\n  color: #212529;\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.bulk-final-confirmation-footer {\n  padding: 1rem;\n  background: #f8f9fa;\n  border-top: 1px solid #dee2e6;\n  display: flex;\n  gap: 0.8rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.bulk-cancel-button-confirmation,\n.bulk-submit-button-confirmation {\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 120px;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.bulk-cancel-button-confirmation {\n  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);\n  color: white;\n  border: 1px solid #5a6268;\n}\n\n.bulk-cancel-button-confirmation:hover:not(:disabled) {\n  background: linear-gradient(135deg, #5a6268 0%, #495057 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.3);\n}\n\n.bulk-submit-button-confirmation {\n  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);\n  color: white;\n  border: 1px solid #004085;\n}\n\n.bulk-submit-button-confirmation:hover:not(:disabled) {\n  background: linear-gradient(135deg, #004085 0%, #003680 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 86, 179, 0.4);\n}\n\n.bulk-cancel-button-confirmation:disabled,\n.bulk-submit-button-confirmation:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.bulk-submit-button-confirmation svg.fa-spinner {\n  animation: spin 1s linear infinite;\n}\n\n.bulk-submit-button-confirmation svg.fa-check {\n  animation: none !important;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Mobile Responsive Styles */\n@media (max-width: 768px) {\n  .bulk-final-confirmation-modal {\n    max-width: 95%;\n    margin: 1rem;\n    border-radius: 12px;\n  }\n\n  .modal-header-confirmation {\n    padding: 1.2rem;\n  }\n\n  .modal-header-confirmation h2 {\n    font-size: 1.3rem;\n  }\n\n  .bulk-final-confirmation-content {\n    padding: 1.5rem;\n  }\n\n  .bulk-final-confirmation-icon svg {\n    font-size: 3rem;\n  }\n\n  .bulk-final-confirmation-title {\n    font-size: 1.2rem;\n  }\n\n  .bulk-final-confirmation-text {\n    font-size: 1rem;\n  }\n\n  .bulk-final-confirmation-changes {\n    padding: 1.2rem;\n  }\n\n  .bulk-final-confirmation-changes li {\n    font-size: 0.95rem;\n  }\n\n  .bulk-final-confirmation-warning {\n    padding: 1.2rem;\n  }\n\n  .bulk-final-confirmation-warning strong {\n    font-size: 0.95rem;\n  }\n\n  .bulk-final-confirmation-warning p {\n    font-size: 0.9rem;\n  }\n\n  .bulk-final-confirmation-question {\n    font-size: 1.1rem;\n  }\n\n  .bulk-final-confirmation-footer {\n    padding: 1.2rem;\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n\n  .bulk-cancel-button-confirmation,\n  .bulk-submit-button-confirmation {\n    width: 100%;\n    max-width: 280px;\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .bulk-final-confirmation-modal {\n    max-width: 98%;\n    margin: 0.5rem;\n    border-radius: 10px;\n  }\n\n  .modal-header-confirmation {\n    padding: 1rem;\n  }\n\n  .modal-header-confirmation h2 {\n    font-size: 1.2rem;\n  }\n\n  .bulk-final-confirmation-content {\n    padding: 1rem;\n  }\n\n  .bulk-final-confirmation-icon svg {\n    font-size: 2.5rem;\n  }\n\n  .bulk-final-confirmation-title {\n    font-size: 1.1rem;\n  }\n\n  .bulk-final-confirmation-text {\n    font-size: 0.95rem;\n  }\n\n  .bulk-final-confirmation-changes {\n    padding: 1rem;\n  }\n\n  .bulk-final-confirmation-changes li {\n    font-size: 0.9rem;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.3rem;\n  }\n\n  .bulk-final-confirmation-warning {\n    padding: 1rem;\n  }\n\n  .bulk-final-confirmation-warning strong {\n    font-size: 0.9rem;\n  }\n\n  .bulk-final-confirmation-warning p {\n    font-size: 0.85rem;\n  }\n\n  .bulk-final-confirmation-question {\n    font-size: 1rem;\n  }\n\n  .bulk-final-confirmation-footer {\n    padding: 1rem;\n  }\n\n  .bulk-cancel-button-confirmation,\n  .bulk-submit-button-confirmation {\n    padding: 0.875rem;\n    font-size: 0.95rem;\n  }\n}\n\n/* Time selection dropdown options cursor fix */\n.collections-container select,\n.collections-container select option,\n.collections-container select option:hover,\n.collections-container select option:focus {\n  cursor: pointer !important;\n}\n\n/* Additional fix for all select elements in collections container */\n.collections-container select {\n  cursor: pointer !important;\n}\n\n.collections-container select option {\n  cursor: pointer !important;\n}\n\n/* Global fix for all select options across the application */\nselect option {\n  cursor: pointer !important;\n}\n\n/* More specific targeting for time period dropdown */\nselect[name=\"shiftFilter\"] option,\nselect[id*=\"shift\"] option,\nselect option[value=\"morning\"],\nselect option[value=\"evening\"],\nselect option[value=\"all\"] {\n  cursor: pointer !important;\n}\n\n/* Make the entire select box clickable with hand pointer */\n.collections-container select:hover,\n.collections-container select:focus {\n  cursor: pointer !important;\n}\n\n/* Ensure all select elements have hand pointer on hover */\nselect:hover,\nselect:focus {\n  cursor: pointer !important;\n}\n\n/* Make the entire shift filter dropdown clickable */\n.shift-filter-dropdown {\n  cursor: pointer !important;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.shift-filter-dropdown:hover {\n  cursor: pointer !important;\n}\n\n.shift-filter-dropdown .shift-filter-select {\n  cursor: pointer !important;\n  position: relative;\n  z-index: 1;\n  /* Make select fill the entire button area */\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  border: none;\n  background: transparent;\n}\n\n/* Ensure the entire dropdown area is clickable */\n.shift-filter-dropdown:hover .shift-filter-select {\n  cursor: pointer !important;\n}\n\n/* Make sure the shift filter dropdown button is fully clickable */\n.filter-button.shift-filter-dropdown {\n  cursor: pointer !important;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filter-button.shift-filter-dropdown:hover {\n  cursor: pointer !important;\n}\n\n/* Ensure any element within the shift filter dropdown has pointer cursor */\n.filter-button.shift-filter-dropdown * {\n  cursor: pointer !important;\n}\n\n.filter-button.shift-filter-dropdown:hover * {\n  cursor: pointer !important;\n}\n\n/* Style for the shift filter text */\n.shift-filter-text {\n  pointer-events: none;\n  /* Allow clicks to pass through to the select element */\n  z-index: 0;\n  position: relative;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n/* Bulk Edit responsive summary layout */\n.bulk-edit-summary {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n@media (max-width: 600px) {\n  .bulk-edit-summary {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 4px !important;\n    width: 100% !important;\n  }\n  .bulk-edit-summary-divider {\n    display: none !important;\n  }\n}\n\n/* Make supplier ID small on mobile screens */\n@media (max-width: 768px) {\n  .customer-id-span {\n    font-size: 12px !important;\n    font-weight: 500 !important;\n  }\n}\n/* Animal Filter CSS */\n.animal-filter-dropdown {\n  cursor: pointer !important;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.animal-filter-dropdown:hover {\n  cursor: pointer !important;\n}\n\n.animal-filter-dropdown .animal-filter-select {\n  cursor: pointer !important;\n  position: relative;\n  z-index: 1;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  border: none;\n  background: transparent;\n}\n\n.animal-filter-dropdown:hover .animal-filter-select {\n  cursor: pointer !important;\n}\n\n.filter-button.animal-filter-dropdown {\n  cursor: pointer !important;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filter-button.animal-filter-dropdown:hover {\n  cursor: pointer !important;\n}\n\n.filter-button.animal-filter-dropdown * {\n  cursor: pointer !important;\n}\n\n.filter-button.animal-filter-dropdown:hover * {\n  cursor: pointer !important;\n}\n\n.animal-filter-text {\n  pointer-events: none;\n  z-index: 0;\n  position: relative;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.animal-filter-icon {\n  pointer-events: none;\n  z-index: 0;\n  position: relative;\n}\n/* Desktop Table Optimization - with horizontal scroll fallback */\n@media (min-width: 769px) {\n  .collections-table-container {\n    max-width: 100% !important;\n    overflow-x: auto !important;\n    padding-bottom: 12px !important;\n  }\n\n  .collections-table {\n    table-layout: fixed !important;\n    width: 100% !important;\n    min-width: 1200px !important;\n    font-size: 13.5px !important;\n  }\n\n  .collections-table th {\n    padding: 4px 1px !important;\n    font-size: 13px !important;\n    text-align: center !important;\n    white-space: normal !important;\n    overflow: visible !important;\n    text-overflow: clip !important;\n    line-height: 1.15 !important;\n  }\n\n  .collections-table td {\n    padding: 3px 1px !important;\n    font-size: 13.5px !important;\n    text-align: center !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n\n  /* Column 1: S.No */\n  .collections-table th:first-child,\n  .collections-table td:first-child {\n    width: 36px !important;\n  }\n\n  /* Column 2: Date & Shift */\n  .collections-table th:nth-child(2),\n  .collections-table td:nth-child(2) {\n    width: 100px !important;\n  }\n\n  /* Column 3: Name */\n  .collections-table th:nth-child(3) {\n    width: 110px !important;\n  }\n  .collections-table td:nth-child(3) {\n    width: 110px !important;\n    text-align: left !important;\n  }\n\n  /* Columns 4-9: QTY, FAT, SNF, CLR, FAT KG, SNF KG */\n  .collections-table th:nth-child(n+4):nth-child(-n+9),\n  .collections-table td:nth-child(n+4):nth-child(-n+9) {\n    width: 45px !important;\n  }\n\n  /* Columns 10 & 11: Fat Step Up, SNF Step Down (with extra room for badges) */\n  .collections-table th:nth-child(10),\n  .collections-table td:nth-child(10),\n  .collections-table th:nth-child(11),\n  .collections-table td:nth-child(11) {\n    width: 80px !important;\n  }\n\n  /* Columns 12+ (Rates, calculations, base values, animal type, amounts) */\n  .collections-table th:nth-child(n+12):not(:last-child),\n  .collections-table td:nth-child(n+12):not(:last-child) {\n    width: 58px !important;\n  }\n\n  /* Column Last: Actions */\n  .collections-table th:last-child,\n  .collections-table td:last-child {\n    width: 85px !important;\n    min-width: 85px !important;\n  }\n}\n/* Pro-rata Step Rate Badges */\n.step-rates-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  justify-content: center;\n  width: 100%;\n}\n\n.step-rate-badge {\n  font-size: 12.5px !important;\n  font-weight: 600 !important;\n  padding: 2px 5px !important;\n  border-radius: 4px !important;\n  display: inline-block !important;\n  text-align: center !important;\n  white-space: nowrap !important;\n  width: auto !important;\n}\n\n.step-rate-badge.fat-badge {\n  background-color: #ecfdf5 !important;\n  color: #047857 !important;\n  border: 1px solid #a7f3d0 !important;\n}\n\n.step-rate-badge.snf-badge {\n  background-color: #fff1f2 !important;\n  color: #be123c !important;\n  border: 1px solid #fecdd3 !important;\n}\n/* Bulk Edit Modal Fields Layout */\n.bulk-edit-fields-container {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  gap: 8px !important;\n  align-items: center !important;\n  flex: 1 !important;\n  width: 100% !important;\n}\n\n.bulk-edit-field-item {\n  display: flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  background: transparent !important;\n  background-color: transparent !important;\n  padding: 4px 8px !important;\n  border: none !important;\n  box-shadow: none !important;\n  box-sizing: border-box !important;\n}\n\n/* Mobile responsive layout for Bulk Edit fields - tight spacing */\n@media (max-width: 768px) {\n  .bulk-edit-fields-container {\n    gap: 2px 2px !important;\n  }\n\n  .bulk-edit-field-item {\n    padding: 1px 2px !important;\n    margin: 0 !important;\n  }\n}\n\n/* Bulk Edit Stats Panel Mobile Alignment */\n@media (max-width: 768px) {\n  .bulk-edit-stats-panel {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 12px 0 !important;\n    padding: 10px 8px !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  .bulk-edit-stats-divider {\n    display: none !important;\n  }\n\n  .bulk-edit-stats-item {\n    width: 100% !important;\n    min-width: 0 !important;\n    flex: none !important;\n    box-sizing: border-box !important;\n  }\n\n  .bulk-edit-stats-item:nth-child(4n+1) {\n    border-right: 1px solid #dee2e6 !important;\n  }\n\n  /* Pro-rata Rate Settings Modal Mobile Buttons styling */\n  .rate-settings-modal .option-btn {\n    padding: 8px 12px !important;\n    font-size: 13px !important;\n    border-radius: 6px !important;\n  }\n\n  .rate-settings-modal .modal-footer .save-button,\n  .rate-settings-modal .modal-footer .cancel-button {\n    padding: 8px 12px !important;\n    font-size: 13px !important;\n    border-radius: 6px !important;\n  }\n\n  .rate-settings-modal .modal-footer {\n    padding: 10px 12px !important;\n    gap: 8px !important;\n  }\n\n  .rate-settings-modal .modal-body {\n    padding: 12px 16px !important;\n  }\n\n  .rate-settings-modal .change-rates-section {\n    margin-bottom: 12px !important;\n    padding: 12px !important;\n  }\n}\n\n/* Ensure Name column cells are always left-aligned in standard/pro-rata preview tables */\n.collections-table td.customer-name-cell,\n.collections-table td:nth-child(3) {\n  text-align: left !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
